import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from 'react-bootstrap';
import { BASE_URL } from '../../../config/axios';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { CSSForSelect10vWWidth, CSSForSelect15vWWidth, CSSForSelectModern, CSSForSelectModern10VWWidth, CSSForSelectModern15VWWidth, handleErrorToast, ProgressModal } from '../../CustomFunctions';
import { AddwithWhiteCircle } from '../../AllSvg';
import Select from 'react-select';
import { Loader, Plus, PlusCircle, Save, Wallet, X } from 'lucide-react';

// const UpdateEmployeeDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);

//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});

//     const [invoiceList, setInvoiceList] = useState([]); // <-- single variable for all fetched data







//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 professional_type: item?.employee_details?.professional_type,
//                 designation_name: item?.employee_details?.designation_name,
//                 current_invoice_amount_two: item.current_invoice_amount_two,
//                 actual_month_two: item.actual_month_two,
//                 current_invoice_amount_twoo: item.current_invoice_amount_two,
//                 actual_amounttt_cumulative_total_two: item.actual_amount_cumulative_total,
//                 actual_amount_cumulative_total: item.actual_amount_cumulative_total,
//                 boq_name_employee_two: item.boq_name_employee_two,
//                 actual_month: item.actual_month,
//                 invoice_amount: item.invoice_amount,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 remaining_amount: item.remaining_amount,
//                 previous_invoice_total_two: item.previous_invoice_total_two,
//                 actual_month_total_previous_two: item.actual_month_total_previous_two,
//                 actual_month_cumulative_total_two: item.actual_month_cumulative_total_two,
//                 cumulative_invoice_total: item.cumulative_invoice_total,



//             }));

//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))

//             setDeductionFormData(initialDeductionData)




//             setFormData(initialData);
//         }
//     }, [invoiceData]);






//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     console.log("errors", errors);
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoiceemployeeupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {

//                             try {

//                             } catch (error) {

//                             }
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully"); // Show success toast
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }

//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Month cannot exceed actual month"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = [...((invoiceData[index]?.actual_month_two) || [])];
//                 const currentInvoiceAmountTwo = [...(invoiceData[index]?.current_invoice_amount_two || [])];

//                 const prevMonthTotal = [...(updatedForm[index]?.actual_month_total_previous_two || [])];
//                 const prevInvoiceTotal = [...(updatedForm[index]?.previous_invoice_total_two || [])];

//                 const cumulativeMonth = [...(updatedForm[index]?.actual_month_cumulative_total_two || [])];
//                 const cumulativeAmount = [...(updatedForm[index]?.actual_amount_cumulative_total || [])];

//                 actualMonthTwo[0] = (
//                     Number(actualMonthTwo[0] || 0).toFixed(2) - Number(deductionMonth || 0).toFixed(2)
//                 )

//                 console.log("actualMonthTwo", actualMonthTwo)



//                 currentInvoiceAmountTwo[0] =
//                     Number(currentInvoiceAmountTwo[0] || 0) -
//                     (Number(deductionAmount || 0) + Number(withheldAmount || 0));



//                 cumulativeMonth[0] =
//                     Number(prevMonthTotal[0] || 0) + Number(actualMonthTwo[0] || 0);
//                 cumulativeAmount[0] =
//                     Number(prevInvoiceTotal[0] || 0) + Number(currentInvoiceAmountTwo[0] || 0);

//                 // calculate sums
//                 const actualMonthsum = actualMonthTwo.reduce((a, b) => a + Number(Number(b).toFixed(2) || 0), 0);
//                 const invoiceAmountSum = currentInvoiceAmountTwo.reduce((a, b) => a + Number(b || 0), 0);
//                 const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
//                 const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month_two: actualMonthTwo,

//                     actual_month: actualMonthsum,
//                     current_invoice_amount_two: currentInvoiceAmountTwo,
//                     actual_month_cumulative_total_two: cumulativeMonth,
//                     actual_amount_cumulative_total: cumulativeAmount,
//                     invoice_amount: invoiceAmountSum,
//                     actual_month_cumulative_total: cumulativeMonthSum,
//                     cumulative_invoice_total: cumulativeAmountSum,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     console.log("total", formData)


//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };



//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//             console.log("filterNullData", filterNullData);
//         }
//     }, [deductionformData])

//     // useEffect(() => {
//     //     const filterNullData = deductionformData.find(
//     //         item => item.invoice_type !== "null"
//     //     );

//     //     setFinalDeductionFormData(filterNullData || {});
//     // }, [deductionformData]);

//     console.log(finalDeductionFormData, "finalDeductionFormData");

//     console.log(finalDeductionFormData, "finalDeductiondormdata")

//     return (
//         <>
//             <button title="Update employee BOQ" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add Employee Deductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add Employeee Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <ModalBody>

//                             <div className='table-box scroll-container-table'>

//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>

//                                             <th className="table-heading-text text-center">Desination <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Professional Type <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Employee Name  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Month  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>

//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Month</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>


//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.designation_name}</td>
//                                                 <td className="align-left width-5vw">{entry.professional_type}</td>
//                                                 <td className="align-left width-5vw">
//                                                     {entry?.boq_name_employee_two?.map((val, subIndex) => (
//                                                         <div key={subIndex} className="mb-2">
//                                                             <input
//                                                                 className="form-input-date width-10vw"
//                                                                 type="text"
//                                                                 value={val}
//                                                                 readOnly
//                                                             />
//                                                         </div>
//                                                     ))}
//                                                 </td>
//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 {/* Deduction Reason */}
//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>

//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }


//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 {deductionformData.some(row => row.invoice_type !== "null") && (
//                                     <button
//                                         type="submit"
//                                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                         disabled={loading}
//                                         onClick={handleSubmit}
//                                     >
//                                         Submit
//                                     </button>
//                                 )}
//                             </div>

//                         </ModalBody>
//                     </Modal >
//             }
//         </>


//     )
// }




// const UpdateEmployeeDeductionInvoice = ({ invoiceData, getData }) => {
//     // Shared cell styles for the per-employee Raised/Passed/Deduction table
//     const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
//     const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
//     const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

//     const [show, setShow] = useState(false);
//     const [formData, setFormData] = useState([]);
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         withheld_deduction_reason: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//         related_item_data: "Employee",

//         // "Both" — unchanged, single value for the whole row
//         deduction_month: "",
//         deduction_amount: "",
//         withheld_deduction_amount: "",

//         // "Deduction" / "WithHeldDeduction" — NEW: per-employee arrays, same indexing
//         // as invoiceData[index].actual_month_two / current_invoice_amount_two / boq_name_employee_two
//         passed_month_two: [],
//         passed_amount_two: [],
//         deduction_month_two: [],       // raised_month[i] - passed_month[i]
//         deduction_amount_two: [],      // used when invoice_type === "Deduction"
//         withheld_deduction_amount_two: [], // used when invoice_type === "WithHeldDeduction"
//     }]);

//     const handleShow = () => setShow(true);
//     const handleClose = () => setShow(false);
//     const [errors, setErrors] = useState({});

//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 professional_type: item?.employee_details?.professional_type,
//                 designation_name: item?.employee_details?.designation_name,
//                 current_invoice_amount_two: item.current_invoice_amount_two,
//                 actual_month_two: item.actual_month_two,
//                 current_invoice_amount_twoo: item.current_invoice_amount_two,
//                 actual_amounttt_cumulative_total_two: item.actual_amount_cumulative_total,
//                 actual_amount_cumulative_total: item.actual_amount_cumulative_total,
//                 boq_name_employee_two: item.boq_name_employee_two,
//                 actual_month: item.actual_month,
//                 invoice_amount: item.invoice_amount,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 remaining_amount: item.remaining_amount,
//                 previous_invoice_total_two: item.previous_invoice_total_two,
//                 actual_month_total_previous_two: item.actual_month_total_previous_two,
//                 actual_month_cumulative_total_two: item.actual_month_cumulative_total_two,
//                 cumulative_invoice_total: item.cumulative_invoice_total,
//             }));

//             const initialDeductionData = invoiceData.map((item) => {
//                 const len = (item.actual_month_two || []).length;
//                 return {
//                     deduction_reason: "",
//                     withheld_deduction_reason: "",
//                     invoice_type: "null",
//                     item_id: item.id,
//                     invoice_id: item.invoice,
//                     project: item.project,
//                     related_item_data: "Employee",
//                     deduction_month: "",
//                     deduction_amount: "",
//                     withheld_deduction_amount: "",

//                     passed_month_two: Array(len).fill(""),
//                     passed_amount_two: Array(len).fill(""),
//                     deduction_month_two: Array(len).fill(0),
//                     deduction_amount_two: Array(len).fill(0),
//                     withheld_deduction_amount_two: Array(len).fill(0),
//                 };
//             });

//             setDeductionFormData(initialDeductionData);
//             setFormData(initialData);
//         }
//     }, [invoiceData]);

//     const [loading, setLoading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};
//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//             }
//             if (row.invoice_type === "Deduction") {
//                 const hasAnyPassed = (row.passed_month_two || []).some((v) => v !== "" && v !== undefined)
//                     || (row.passed_amount_two || []).some((v) => v !== "" && v !== undefined);
//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 if (!hasAnyPassed) newErrors[`deduction_month_${index}`] = "Enter Passed values for at least one employee";
//             }
//             if (row.invoice_type === "WithHeldDeduction") {
//                 const hasAnyPassed = (row.passed_month_two || []).some((v) => v !== "" && v !== undefined)
//                     || (row.passed_amount_two || []).some((v) => v !== "" && v !== undefined);
//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 if (!hasAnyPassed) newErrors[`deduction_month_${index}`] = "Enter Passed values for at least one employee";
//             }
//         });
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!validateForm()) return;

//         setLoading(true);
//         setShowProgressModal(true);
//         setUploadProgress(0);
//         const loadingToastId = toast.loading("Loading: Please wait...");

//         try {
//             let res = await axios.put(
//                 `${BASE_URL}/siteproject/newinvoiceemployeeupdatedelete/null/`,
//                 formData,
//                 {
//                     onUploadProgress: (progressEvent) => {
//                         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                         setUploadProgress(percentCompleted);
//                     },
//                 }
//             );

//             if (res.status === 200) {
//                 try {
//                     const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                     if (res2.status === 201 || res2.status === 200) {
//                         await getData();
//                         handleClose();
//                         setTimeout(() => {
//                             toast.dismiss(loadingToastId);
//                             toast.success("Data Submitted Successfully");
//                         }, 4000);
//                     }
//                 } catch (error) {
//                     handleErrorToast(error, loadingToastId);
//                 }
//             } else {
//                 alert(res);
//             }
//         } catch (err) {
//             handleErrorToast(err, loadingToastId);
//         } finally {
//             setTimeout(() => {
//                 setShowProgressModal(false);
//             }, 2000);
//             setTimeout(() => {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }, 4000);
//         }
//     };

//     // ---- "Both" path — UNCHANGED from original, single value affecting index 0 ----
//     const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
//         setFormData((prevFormData) => {
//             const updatedForm = [...prevFormData];
//             const actualMonthTwo = [...((invoiceData[index]?.actual_month_two) || [])];
//             const currentInvoiceAmountTwo = [...(invoiceData[index]?.current_invoice_amount_two || [])];
//             const prevMonthTotal = [...(updatedForm[index]?.actual_month_total_previous_two || [])];
//             const prevInvoiceTotal = [...(updatedForm[index]?.previous_invoice_total_two || [])];
//             const cumulativeMonth = [...(updatedForm[index]?.actual_month_cumulative_total_two || [])];
//             const cumulativeAmount = [...(updatedForm[index]?.actual_amount_cumulative_total || [])];
//             const remainingMonth = [...(updatedForm[index]?.boq_construction_period || [])];
//             const contractMonth = [...(updatedForm[index]?.boq_OM_period || [])];
//             const oandmMonth = [...(updatedForm[index]?.actual_amount_cumulative_total || [])];
//             const totalContractAmount = [...(updatedForm[index]?.actual_amount_cumulative_total || [])];

//             actualMonthTwo[0] = (Number(actualMonthTwo[0] || 0).toFixed(2) - Number(deductionMonth || 0).toFixed(2));
//             currentInvoiceAmountTwo[0] = Number(currentInvoiceAmountTwo[0] || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
//             cumulativeMonth[0] = Number(prevMonthTotal[0] || 0) + Number(actualMonthTwo[0] || 0);
//             cumulativeAmount[0] = Number(prevInvoiceTotal[0] || 0) + Number(currentInvoiceAmountTwo[0] || 0);

//             const actualMonthsum = actualMonthTwo.reduce((a, b) => a + Number(Number(b).toFixed(2) || 0), 0);
//             const invoiceAmountSum = currentInvoiceAmountTwo.reduce((a, b) => a + Number(b || 0), 0);
//             const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
//             const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

//             updatedForm[index] = {
//                 ...updatedForm[index],
//                 actual_month_two: actualMonthTwo,
//                 actual_month: actualMonthsum,
//                 current_invoice_amount_two: currentInvoiceAmountTwo,
//                 actual_month_cumulative_total_two: cumulativeMonth,
//                 actual_amount_cumulative_total: cumulativeAmount,
//                 invoice_amount: invoiceAmountSum,
//                 actual_month_cumulative_total: cumulativeMonthSum,
//                 cumulative_invoice_total: cumulativeAmountSum,
//                 actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                 remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//             };



//             return updatedForm;
//         });
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         const row = deductionformData[index] || {};
//         const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0);
//         const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
//         const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
//         const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//         const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//         if (numericValue < 0) {
//             setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
//             return;
//         }
//         if (name === "deduction_month" && deductionMonth > actualMonth) {
//             setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Month cannot exceed actual month" }));
//             return;
//         }
//         if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
//             setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
//             return;
//         }

//         setErrors((prev) => {
//             const newErrors = { ...prev };
//             delete newErrors[`${name}_${index}`];
//             return newErrors;
//         });

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];
//             updated[index] = { ...updated[index], [name]: value };
//             return updated;
//         });

//         applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
//     };

//     // ---- "Deduction" / "WithHeldDeduction" path — NEW per-employee Raised/Passed ----

//     // Absolute recompute for one employee index (empIndex) inside a designation row (index).
//     // Writes into formData[index].deduction_amount / deduction_reason arrays at the same
//     // empIndex — deduction_amount holds the amount, deduction_reason holds the MONTH value
//     // (per instruction), not text.
//     const applyToFormDataPerEmployee = (index, empIndex, deductionMonth, deductionAmount) => {
//         setFormData((prevFormData) => {
//             const updatedForm = [...prevFormData];
//             const actualMonthTwo = [...((invoiceData[index]?.actual_month_two) || [])];
//             const currentInvoiceAmountTwo = [...(invoiceData[index]?.current_invoice_amount_two || [])];
//             const prevMonthTotal = [...(invoiceData[index]?.actual_month_total_previous_two || [])];
//             const prevInvoiceTotal = [...(invoiceData[index]?.previous_invoice_total_two || [])];


//             // actualMonthTwo[empIndex] = Number((Number(actualMonthTwo[empIndex] || 0) - Number(deductionMonth || 0)).toFixed(2));
//             // currentInvoiceAmountTwo[empIndex] = Number(currentInvoiceAmountTwo[empIndex] || 0) - Number(deductionAmount || 0);

//             // previous_invoice_total_two / actual_month_total_previous_two can have fewer
//             // entries than employees (as in the sample data) — fall back to index 0.

//             const row = deductionformData[index] || {};
//             const totalDeductionMonth = (row.deduction_month_two || []).reduce((a, b) => a + Number(b || 0), 0);
//             const totalDeductionAmount = row.invoice_type === "WithHeldDeduction"
//                 ? (row.withheld_deduction_amount_two || []).reduce((a, b) => a + Number(b || 0), 0)
//                 : (row.deduction_amount_two || []).reduce((a, b) => a + Number(b || 0), 0);


//             const deductionAmountArr = [...(updatedForm[index]?.deduction_amount || [])];
//             const deductionReasonArr = [...(updatedForm[index]?.deduction_reason || [])];
//             deductionAmountArr[empIndex] = deductionAmount || 0;
//             deductionReasonArr[empIndex] = deductionMonth || 0;
//             const actualMonthSum = deductionReasonArr.reduce((a, b) => a + Number(b || 0), 0);
//             const invoiceAmountSum = deductionAmountArr.reduce((a, b) => a + Number(b || 0), 0);
//             const cumulativeMonth = deductionReasonArr.map((m, i) => {
//                 if (i < prevMonthTotal.length) {
//                     return Number(prevMonthTotal[i] || 0) + Number(m || 0);
//                 }
//                 return Number(m || 0); // No previous value, keep current only
//             });

//             const cumulativeAmount = deductionAmountArr.map((a, i) => {
//                 if (i < prevInvoiceTotal.length) {
//                     return Number(prevInvoiceTotal[i] || 0) + Number(a || 0);
//                 }
//                 return Number(a || 0); // No previous value, keep current only
//             });
//             const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
//             const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

//             updatedForm[index] = {
//                 ...updatedForm[index],
//                 actual_month_two: deductionReasonArr,
//                 actual_month: actualMonthSum,
//                 current_invoice_amount_two: deductionAmountArr,
//                 actual_month_cumulative_total_two: cumulativeMonth,
//                 actual_amount_cumulative_total: cumulativeAmount,
//                 invoice_amount: invoiceAmountSum,
//                 actual_month_cumulative_total: cumulativeMonthSum,
//                 cumulative_invoice_total: cumulativeAmountSum,
//                 actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + totalDeductionMonth,
//                 remaining_amount: Number(invoiceData[index]?.remaining_amount) + totalDeductionAmount,
//                 deduction_amount: deductionAmountArr,
//                 deduction_reason: deductionReasonArr,
//             };

//             return updatedForm;
//         });
//     };

//     // Passed input change for one employee (empIndex) within row (index).
//     // deduction_month_two[empIndex]      = raised_month[empIndex]  - passed_month[empIndex]
//     // deduction_amount_two[empIndex]     = raised_amount[empIndex] - passed_amount[empIndex]  (type: Deduction)
//     // withheld_deduction_amount_two[empIndex] = raised_amount[empIndex] - passed_amount[empIndex]  (type: WithHeldDeduction)
//     const handlePassedChange = (index, empIndex, field, value) => {
//         const numericValue = Number(value);
//         if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
//             setErrors((prev) => ({ ...prev, [`${field}_${index}_${empIndex}`]: "Value cannot be less than 0" }));
//             return;
//         }

//         const row = deductionformData[index] || {};
//         const raisedMonth = Number(invoiceData[index]?.actual_month_two?.[empIndex] || 0);
//         const raisedAmount = Number(invoiceData[index]?.current_invoice_amount_two?.[empIndex] || 0);

//         const passedMonthTwo = [...(row.passed_month_two || [])];
//         const passedAmountTwo = [...(row.passed_amount_two || [])];
//         if (field === "month") passedMonthTwo[empIndex] = value;
//         else passedAmountTwo[empIndex] = value;

//         const passedMonth = Number(passedMonthTwo[empIndex] || 0);
//         const passedAmount = Number(passedAmountTwo[empIndex] || 0);

//         if (field === "month" && passedMonth > raisedMonth) {
//             setErrors((prev) => ({ ...prev, [`month_${index}_${empIndex}`]: "Passed month cannot exceed raised month" }));
//             return;
//         }
//         if (field === "amount" && passedAmount > raisedAmount) {
//             setErrors((prev) => ({ ...prev, [`amount_${index}_${empIndex}`]: "Passed amount cannot exceed raised amount" }));
//             return;
//         }

//         setErrors((prev) => {
//             const newErrors = { ...prev };
//             delete newErrors[`${field}_${index}_${empIndex}`];
//             delete newErrors[`deduction_month_${index}`];
//             return newErrors;
//         });

//         const deductionMonth = Number((raisedMonth - passedMonth).toFixed(2));
//         const deductionAmount = raisedAmount - passedAmount;

//         const deductionMonthTwo = [...(row.deduction_month_two || [])];
//         const deductionAmountTwo = [...(row.deduction_amount_two || [])];
//         const withheldAmountTwo = [...(row.withheld_deduction_amount_two || [])];
//         deductionMonthTwo[empIndex] = deductionMonth;
//         if (row.invoice_type === "WithHeldDeduction") {
//             withheldAmountTwo[empIndex] = deductionAmount;
//         } else {
//             deductionAmountTwo[empIndex] = deductionAmount;
//         }

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];
//             updated[index] = {
//                 ...updated[index],
//                 passed_month_two: passedMonthTwo,
//                 passed_amount_two: passedAmountTwo,
//                 deduction_month_two: deductionMonthTwo,
//                 deduction_amount_two: deductionAmountTwo,
//                 withheld_deduction_amount_two: withheldAmountTwo,
//             };
//             return updated;
//         });

//         applyToFormDataPerEmployee(index, empIndex, passedMonth, passedAmount);
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },
//     ];
//     const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

//     const deductionTypeChange = (selectedOption, index) => {
//         const newType = selectedOption ? selectedOption.value : "null";
//         const len = (invoiceData[index]?.actual_month_two || []).length;

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];
//             updated[index] = {
//                 ...updated[index],
//                 invoice_type: newType,
//                 deduction_month: "",
//                 deduction_amount: "",
//                 withheld_deduction_amount: "",
//                 passed_month_two: Array(len).fill(""),
//                 passed_amount_two: Array(len).fill(""),
//                 deduction_month_two: Array(len).fill(0),
//                 deduction_amount_two: Array(len).fill(0),
//                 withheld_deduction_amount_two: Array(len).fill(0),
//             };
//             return updated;
//         });

//         // Reset the row's cascade back to the raw invoiceData baseline.
//         applyToFormData(index, 0, 0, 0);
//         for (let empIndex = 0; empIndex < len; empIndex++) {
//             applyToFormDataPerEmployee(index, empIndex, 0, 0);
//         }

//         setErrors((prev) => {
//             const newErrors = { ...prev };
//             Object.keys(newErrors).forEach((key) => {
//                 if (key.endsWith(`_${index}`) || key.includes(`_${index}_`)) delete newErrors[key];
//             });
//             return newErrors;
//         });
//     };

//     // Backend payload builder:
//     // - "Both" → one object per row, scalar values (unchanged behavior)
//     // - "Deduction" / "WithHeldDeduction" → one SEPARATE object per employee
//     //   (same item_id/invoice_id/project, scalar deduction_month/deduction_amount —
//     //   NOT arrays). If a row has 2 employees with passed values entered, this produces 2 objects.
//     useEffect(() => {
//         const expanded = [];

//         deductionformData.forEach((row) => {
//             if (row.invoice_type === "null") return;

//             if (row.invoice_type === "Both") {
//                 expanded.push({
//                     deduction_reason: row.deduction_reason || "",
//                     withheld_deduction_reason: row.withheld_deduction_reason || "",
//                     invoice_type: row.invoice_type,
//                     item_id: row.item_id,
//                     invoice_id: row.invoice_id,
//                     project: row.project,
//                     related_item_data: "Employee",
//                     deduction_month: row.deduction_month,
//                     deduction_amount: row.deduction_amount,
//                     withheld_deduction_amount: row.withheld_deduction_amount,
//                 });
//                 return;
//             }

//             const len = Math.max(
//                 (row.deduction_month_two || []).length,
//                 (row.deduction_amount_two || []).length,
//                 (row.withheld_deduction_amount_two || []).length
//             );

//             for (let empIndex = 0; empIndex < len; empIndex++) {
//                 const passedMonthEntered = row.passed_month_two?.[empIndex] !== "" && row.passed_month_two?.[empIndex] !== undefined;
//                 const passedAmountEntered = row.passed_amount_two?.[empIndex] !== "" && row.passed_amount_two?.[empIndex] !== undefined;
//                 if (!passedMonthEntered && !passedAmountEntered) continue; // skip employees with no input

//                 expanded.push({
//                     deduction_reason: row.deduction_reason || "",
//                     withheld_deduction_reason: row.withheld_deduction_reason || "",
//                     invoice_type: row.invoice_type,
//                     item_id: row.item_id,
//                     invoice_id: row.invoice_id,
//                     project: row.project,
//                     related_item_data: "Employee",
//                     deduction_month: row.deduction_month_two?.[empIndex] ?? 0,
//                     deduction_amount: row.invoice_type === "Deduction" ? (row.deduction_amount_two?.[empIndex] ?? 0) : 0,
//                     withheld_deduction_amount: row.invoice_type === "WithHeldDeduction" ? (row.withheld_deduction_amount_two?.[empIndex] ?? 0) : 0,
//                 });
//             }
//         });

//         setFinalDeductionFormData(expanded);
//     }, [deductionformData]);

//     console.log("Final Deduction Form Data:", finalDeductionFormData);
//     console.log("Deduction Form Data:", formData);
//     // Raised (read-only) + Passed (input) + auto Deduction, one block per employee.
//     const renderRaisedPassedRows = (index) => {
//         const raisedMonths = invoiceData[index]?.actual_month_two || [];
//         const raisedAmounts = invoiceData[index]?.current_invoice_amount_two || [];
//         const empNames = invoiceData[index]?.boq_name_employee_two || [];
//         const row = deductionformData[index] || {};
//         const passedMonths = row.passed_month_two || [];
//         const passedAmounts = row.passed_amount_two || [];
//         const deductionMonths = row.deduction_month_two || [];
//         const deductionAmounts = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount_two || [] : row.deduction_amount_two || [];

//         return (
//             <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
//                 <thead>
//                     <tr style={{ background: '#f8fafc' }}>
//                         <th rowSpan={2} style={thStyle}>Employee</th>
//                         <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Raised</th>
//                         <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
//                         <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
//                     </tr>
//                     <tr style={{ background: '#f8fafc' }}>
//                         <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
//                         <th style={thSubStyle}>Amount</th>
//                         <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
//                         <th style={thSubStyle}>Amount</th>
//                         <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Month</th>
//                         <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {raisedMonths.map((_, empIndex) => (
//                         <tr
//                             key={empIndex}
//                             style={{
//                                 background: empIndex % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                 borderTop: '1px solid #f1f5f9',
//                             }}
//                         >
//                             <td style={{ ...tdStyle, fontWeight: 600, color: '#1e293b' }}>
//                                 {empNames[empIndex] || `Emp ${empIndex + 1}`}
//                             </td>

//                             {/* Raised — read-only */}
//                             <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>{raisedMonths[empIndex]}</td>
//                             <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmounts[empIndex]}</td>

//                             {/* Passed — inputs */}
//                             <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
//                                 <input
//                                     type="number"
//                                     min="0"
//                                     value={passedMonths[empIndex] ?? ""}
//                                     onChange={(e) => handlePassedChange(index, empIndex, "month", e.target.value)}
//                                     className={`modern-select ${errors[`month_${index}_${empIndex}`] ? "error" : ""}`}
//                                     style={{ width: '70px', fontSize: '12px' }}
//                                 />
//                                 {errors[`month_${index}_${empIndex}`] && (
//                                     <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}_${empIndex}`]}</div>
//                                 )}
//                             </td>
//                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                 <input
//                                     type="number"
//                                     min="0"
//                                     value={passedAmounts[empIndex] ?? ""}
//                                     onChange={(e) => handlePassedChange(index, empIndex, "amount", e.target.value)}
//                                     className={`modern-select ${errors[`amount_${index}_${empIndex}`] ? "error" : ""}`}
//                                     style={{ width: '70px', fontSize: '12px' }}
//                                 />
//                                 {errors[`amount_${index}_${empIndex}`] && (
//                                     <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}_${empIndex}`]}</div>
//                                 )}
//                             </td>

//                             {/* Deduction — auto-computed */}
//                             <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
//                                 {deductionMonths[empIndex] ?? 0}
//                             </td>
//                             <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
//                                 ₹{deductionAmounts[empIndex] ?? 0}
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         );
//     };

//     return (
//         <>
//             <button title="Update employee BOQ" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
//                 <PlusCircle size={13} /> Add Employee Deductions
//             </button>

//             {showProgressModal ? (
//                 <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
//             ) : (
//                 <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
//                     <Modal.Header className="modern-modal-header">
//                         <div className="header-content">
//                             <div style={{ color: "white" }}>
//                                 <Wallet size={24} />
//                             </div>
//                             <div>
//                                 <Modal.Title>Employee Invoice Deductions</Modal.Title>
//                                 <p className="header-subtitle" style={{ color: "white" }}>Add deductions per employee</p>
//                             </div>
//                         </div>
//                         <button className="close-btn" onClick={handleClose}>
//                             <X size={20} />
//                         </button>
//                     </Modal.Header>

//                     <Modal.Body className="modern-modal-body">
//                         <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
//                             <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                 <thead className="table-heading">
//                                     <tr style={{ background: '#f1f5f9' }}>
//                                         <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
//                                         <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Designation</th>
//                                         <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
//                                         <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
//                                         <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {formData?.map((entry, index) => {
//                                         const rowType = deductionformData[index]?.invoice_type;
//                                         return (
//                                             <tr
//                                                 key={index}
//                                                 className="progress-row"
//                                                 style={{
//                                                     background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                                     borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
//                                                 }}
//                                             >
//                                                 <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
//                                                 <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
//                                                     <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.designation_name}</div>
//                                                     <div style={{ fontSize: '10px', color: '#94a3b8' }}>{entry.professional_type}</div>
//                                                     {entry?.boq_name_employee_two?.map((val, subIndex) => (
//                                                         <div key={subIndex} style={{ fontSize: '11px', color: '#475569', marginTop: '2px' }}>{val}</div>
//                                                     ))}
//                                                 </td>
//                                                 <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
//                                                     <Select
//                                                         options={deductionOptions}
//                                                         isSearchable
//                                                         isClearable
//                                                         onChange={(option) => deductionTypeChange(option, index)}
//                                                         placeholder="Select Type"
//                                                         value={deductionOptions.find(option => option.value === rowType) || null}
//                                                         styles={CSSForSelectModern10VWWidth}
//                                                     />
//                                                 </td>

//                                                 {rowType === "Both" ? (
//                                                     <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
//                                                         <div className="form-field" style={{ marginBottom: '6px' }}>
//                                                             <textarea
//                                                                 placeholder="Deduction Reason"
//                                                                 className={errors[`deduction_reason_${index}`] ? "error" : ""}
//                                                                 value={deductionformData[index]?.deduction_reason || ""}
//                                                                 onChange={(e) => {
//                                                                     const { value } = e.target;
//                                                                     setDeductionFormData((prevData) => {
//                                                                         const updated = [...prevData];
//                                                                         updated[index] = { ...updated[index], deduction_reason: value };
//                                                                         return updated;
//                                                                     });
//                                                                 }}
//                                                             />
//                                                             {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
//                                                         </div>
//                                                         <div className="progress-badge" style={{ gap: '6px' }}>
//                                                             <span className="badge-label">Month</span>
//                                                             <input
//                                                                 type="number"
//                                                                 min="0"
//                                                                 max={formData[index]?.actual_month}
//                                                                 value={deductionformData[index]?.deduction_month || ""}
//                                                                 onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
//                                                                 className="modern-select"
//                                                                 style={{ width: '90px' }}
//                                                             />
//                                                         </div>
//                                                         {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
//                                                         <div className="progress-badge approved" style={{ gap: '6px' }}>
//                                                             <span className="badge-label">Amount</span>
//                                                             <input
//                                                                 type="number"
//                                                                 value={deductionformData[index]?.deduction_amount || ""}
//                                                                 onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
//                                                                 className="modern-select"
//                                                                 style={{ width: '90px' }}
//                                                             />
//                                                         </div>
//                                                         {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
//                                                     </td>
//                                                 ) : rowType === "Deduction" ? (
//                                                     <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
//                                                         <div className="form-field" style={{ marginBottom: '6px' }}>
//                                                             <textarea
//                                                                 placeholder="Deduction Reason"
//                                                                 className={errors[`deduction_reason_${index}`] ? "error" : ""}
//                                                                 value={deductionformData[index]?.deduction_reason || ""}
//                                                                 onChange={(e) => {
//                                                                     const { value } = e.target;
//                                                                     setDeductionFormData((prevData) => {
//                                                                         const updated = [...prevData];
//                                                                         updated[index] = { ...updated[index], deduction_reason: value };
//                                                                         return updated;
//                                                                     });
//                                                                 }}
//                                                             />
//                                                             {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
//                                                         </div>
//                                                         {renderRaisedPassedRows(index)}
//                                                         {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
//                                                     </td>
//                                                 ) : (
//                                                     <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
//                                                 )}

//                                                 {rowType === "Both" ? (
//                                                     <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
//                                                         <div className="form-field" style={{ marginBottom: '6px' }}>
//                                                             <textarea
//                                                                 placeholder="Withheld Reason"
//                                                                 className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
//                                                                 value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                 onChange={(e) => {
//                                                                     const { value } = e.target;
//                                                                     setDeductionFormData((prevData) => {
//                                                                         const updated = [...prevData];
//                                                                         updated[index] = { ...updated[index], withheld_deduction_reason: value };
//                                                                         return updated;
//                                                                     });
//                                                                 }}
//                                                             />
//                                                             {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
//                                                         </div>
//                                                         <div className="progress-badge approved" style={{ gap: '6px' }}>
//                                                             <span className="badge-label">Amount</span>
//                                                             <input
//                                                                 type="number"
//                                                                 value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                 onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
//                                                                 className="modern-select"
//                                                                 style={{ width: '90px' }}
//                                                             />
//                                                         </div>
//                                                         {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
//                                                     </td>
//                                                 ) : rowType === "WithHeldDeduction" ? (
//                                                     <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
//                                                         <div className="form-field" style={{ marginBottom: '6px' }}>
//                                                             <textarea
//                                                                 placeholder="Withheld Reason"
//                                                                 className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
//                                                                 value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                 onChange={(e) => {
//                                                                     const { value } = e.target;
//                                                                     setDeductionFormData((prevData) => {
//                                                                         const updated = [...prevData];
//                                                                         updated[index] = { ...updated[index], withheld_deduction_reason: value };
//                                                                         return updated;
//                                                                     });
//                                                                 }}
//                                                             />
//                                                             {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
//                                                         </div>
//                                                         {renderRaisedPassedRows(index)}
//                                                         {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
//                                                     </td>
//                                                 ) : (
//                                                     <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
//                                                 )}
//                                             </tr>
//                                         );
//                                     })}
//                                 </tbody>
//                             </table>
//                         </div>

//                         <div className="form-actions" style={{ marginTop: '16px' }}>
//                             <div></div>
//                             <div className="submit-buttons">
//                                 <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
//                                 {deductionformData.some(row => row.invoice_type !== "null") && (
//                                     <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
//                                         {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
//                                         <span>{loading ? 'Submitting...' : 'Submit'}</span>
//                                     </button>
//                                 )}
//                             </div>
//                         </div>
//                     </Modal.Body>
//                 </Modal>
//             )}
//         </>
//     );
// };
// Saved passed values nikalo (agar numeric nahi hai to raised value fallback)
const getPassedDefaults = (item) => {
    const len = (item?.actual_month_two || []).length;
    const pick = (v, fb) => (v !== undefined && v !== null && v !== "" && !isNaN(Number(v)) ? v : fb);
    return {
        len,
        months: Array.from({ length: len }, (_, i) => pick(item?.deduction_reason?.[i], item?.actual_month_two?.[i] ?? "")),
        amounts: Array.from({ length: len }, (_, i) => pick(item?.deduction_amount?.[i], item?.current_invoice_amount_two?.[i] ?? "")),
    };
};

const UpdateEmployeeDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the per-employee Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",
        related_item_data: "Employee",

        // "Both" — unchanged, single value for the whole row
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — per-employee arrays, same indexing
        // as invoiceData[index].actual_month_two / current_invoice_amount_two / boq_name_employee_two
        passed_month_two: [],
        passed_amount_two: [],
        deduction_month_two: [],       // raised_month[i] - passed_month[i]
        deduction_amount_two: [],      // used when invoice_type === "Deduction"
        withheld_deduction_amount_two: [], // used when invoice_type === "WithHeldDeduction"
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                professional_type: item?.employee_details?.professional_type,

                designation_name: item?.employee_details?.designation_name,
                current_invoice_amount_two: item.current_invoice_amount_two,
                actual_month_two: item.actual_month_two,
                current_invoice_amount_twoo: item.current_invoice_amount_two,
                actual_amounttt_cumulative_total_two: item.actual_amount_cumulative_total,
                actual_amount_cumulative_total: item.actual_amount_cumulative_total,
                boq_name_employee_two: item.boq_name_employee_two,
                actual_month: item.actual_month,
                invoice_amount: item.invoice_amount,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                remaining_amount: item.remaining_amount,
                previous_invoice_total_two: item.previous_invoice_total_two,
                actual_month_total_previous_two: item.actual_month_total_previous_two,
                actual_month_cumulative_total_two: item.actual_month_cumulative_total_two,
                cumulative_invoice_total: item.cumulative_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => {
                const { len, months, amounts } = getPassedDefaults(item);
                return {
                    deduction_reason: "",
                    withheld_deduction_reason: "",
                    invoice_type: "null",
                    item_id: item.id,
                    invoice_id: item.invoice,
                    project: item.project,
                    related_item_data: "Employee",
                    deduction_month: "",
                    deduction_amount: "",
                    withheld_deduction_amount: "",

                    passed_month_two: months,
                    passed_amount_two: amounts,
                    deduction_month_two: Array(len).fill(0),
                    deduction_amount_two: Array(len).fill(0),
                    withheld_deduction_amount_two: Array(len).fill(0),
                };
            });

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasAnyPassed = (row.passed_month_two || []).some((v) => v !== "" && v !== undefined)
                    || (row.passed_amount_two || []).some((v) => v !== "" && v !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasAnyPassed) newErrors[`deduction_month_${index}`] = "Enter Passed values for at least one employee";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasAnyPassed = (row.passed_month_two || []).some((v) => v !== "" && v !== undefined)
                    || (row.passed_amount_two || []).some((v) => v !== "" && v !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasAnyPassed) newErrors[`deduction_month_${index}`] = "Enter Passed values for at least one employee";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoiceemployeeupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    if (finalDeductionFormData.length > 0) {
                        const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                        if (res2.status !== 201 && res2.status !== 200) throw new Error("Deduction save failed");
                    }
                    await getData();
                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId);
                        toast.success("Data Submitted Successfully");
                    }, 4000);
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // ---- "Both" path — UNCHANGED from original, single value affecting index 0 ----
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];
            const actualMonthTwo = [...((invoiceData[index]?.actual_month_two) || [])];
            const currentInvoiceAmountTwo = [...(invoiceData[index]?.current_invoice_amount_two || [])];
            const prevMonthTotal = [...(updatedForm[index]?.actual_month_total_previous_two || [])];
            const prevInvoiceTotal = [...(updatedForm[index]?.previous_invoice_total_two || [])];
            const cumulativeMonth = [...(updatedForm[index]?.actual_month_cumulative_total_two || [])];
            const cumulativeAmount = [...(updatedForm[index]?.actual_amount_cumulative_total || [])];

            actualMonthTwo[0] = (Number(actualMonthTwo[0] || 0).toFixed(2) - Number(deductionMonth || 0).toFixed(2));
            currentInvoiceAmountTwo[0] = Number(currentInvoiceAmountTwo[0] || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            cumulativeMonth[0] = Number(prevMonthTotal[0] || 0) + Number(actualMonthTwo[0] || 0);
            cumulativeAmount[0] = Number(prevInvoiceTotal[0] || 0) + Number(currentInvoiceAmountTwo[0] || 0);

            const actualMonthsum = actualMonthTwo.reduce((a, b) => a + Number(Number(b).toFixed(2) || 0), 0);
            const invoiceAmountSum = currentInvoiceAmountTwo.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month_two: actualMonthTwo,
                actual_month: actualMonthsum,
                current_invoice_amount_two: currentInvoiceAmountTwo,
                actual_month_cumulative_total_two: cumulativeMonth,
                actual_amount_cumulative_total: cumulativeAmount,
                invoice_amount: invoiceAmountSum,
                actual_month_cumulative_total: cumulativeMonthSum,
                cumulative_invoice_total: cumulativeAmountSum,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Month cannot exceed actual month" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — per-employee Raised/Passed ----

    // totalDeductionMonth / totalDeductionAmount handlePassedChange se fresh aate hain (stale state nahi)
    const applyToFormDataPerEmployee = (index, empIndex, deductionMonth, deductionAmount, totalDeductionMonth = 0, totalDeductionAmount = 0) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];
            const prevMonthTotal = [...(invoiceData[index]?.actual_month_total_previous_two || [])];
            const prevInvoiceTotal = [...(invoiceData[index]?.previous_invoice_total_two || [])];

            const deductionAmountArr = [...(updatedForm[index]?.deduction_amount || [])];
            const deductionReasonArr = [...(updatedForm[index]?.deduction_reason || [])];
            deductionAmountArr[empIndex] = deductionAmount || 0;
            deductionReasonArr[empIndex] = deductionMonth || 0;
            const actualMonthSum = deductionReasonArr.reduce((a, b) => a + Number(b || 0), 0);
            const invoiceAmountSum = deductionAmountArr.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeMonth = deductionReasonArr.map((m, i) => {
                if (i < prevMonthTotal.length) {
                    return Number(prevMonthTotal[i] || 0) + Number(m || 0);
                }
                return Number(m || 0); // No previous value, keep current only
            });

            const cumulativeAmount = deductionAmountArr.map((a, i) => {
                if (i < prevInvoiceTotal.length) {
                    return Number(prevInvoiceTotal[i] || 0) + Number(a || 0);
                }
                return Number(a || 0); // No previous value, keep current only
            });
            const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month_two: deductionReasonArr,
                actual_month: actualMonthSum,
                current_invoice_amount_two: deductionAmountArr,
                actual_month_cumulative_total_two: cumulativeMonth,
                actual_amount_cumulative_total: cumulativeAmount,
                invoice_amount: invoiceAmountSum,
                actual_month_cumulative_total: cumulativeMonthSum,
                cumulative_invoice_total: cumulativeAmountSum,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + totalDeductionMonth,
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + totalDeductionAmount,
                deduction_amount: deductionAmountArr,
                deduction_reason: deductionReasonArr,
            };

            return updatedForm;
        });
    };

    // Passed input change for one employee (empIndex) within row (index).
    // deduction_month_two[empIndex]           = raised_month[empIndex]  - passed_month[empIndex]
    // deduction_amount_two[empIndex]          = raised_amount[empIndex] - passed_amount[empIndex]  (type: Deduction)
    // withheld_deduction_amount_two[empIndex] = raised_amount[empIndex] - passed_amount[empIndex]  (type: WithHeldDeduction)
    const handlePassedChange = (index, empIndex, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}_${empIndex}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month_two?.[empIndex] || 0);
        const raisedAmount = Number(invoiceData[index]?.current_invoice_amount_two?.[empIndex] || 0);

        const passedMonthTwo = [...(row.passed_month_two || [])];
        const passedAmountTwo = [...(row.passed_amount_two || [])];
        if (field === "month") passedMonthTwo[empIndex] = value;
        else passedAmountTwo[empIndex] = value;

        const passedMonth = Number(passedMonthTwo[empIndex] || 0);
        const passedAmount = Number(passedAmountTwo[empIndex] || 0);

        if (field === "month" && passedMonth > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}_${empIndex}`]: "Passed month cannot exceed raised month" }));
            return;
        }
        if (field === "amount" && passedAmount > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}_${empIndex}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}_${empIndex}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonth).toFixed(2));
        const deductionAmount = raisedAmount - passedAmount;

        const deductionMonthTwo = [...(row.deduction_month_two || [])];
        const deductionAmountTwo = [...(row.deduction_amount_two || [])];
        const withheldAmountTwo = [...(row.withheld_deduction_amount_two || [])];
        deductionMonthTwo[empIndex] = deductionMonth;
        if (row.invoice_type === "WithHeldDeduction") {
            withheldAmountTwo[empIndex] = deductionAmount;
        } else {
            deductionAmountTwo[empIndex] = deductionAmount;
        }

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                passed_month_two: passedMonthTwo,
                passed_amount_two: passedAmountTwo,
                deduction_month_two: deductionMonthTwo,
                deduction_amount_two: deductionAmountTwo,
                withheld_deduction_amount_two: withheldAmountTwo,
            };
            return updated;
        });

        // Fresh totals (updated arrays se)
        const sum = (arr) => arr.reduce((a, b) => a + Number(b || 0), 0);
        const totalDeductionMonth = sum(deductionMonthTwo);
        const totalDeductionAmount = sum(row.invoice_type === "WithHeldDeduction" ? withheldAmountTwo : deductionAmountTwo);

        applyToFormDataPerEmployee(index, empIndex, passedMonth, passedAmount, totalDeductionMonth, totalDeductionAmount);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";
        const len = (invoiceData[index]?.actual_month_two || []).length;
        const { months, amounts } = getPassedDefaults(invoiceData[index]);

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month_two: months,
                passed_amount_two: amounts,
                deduction_month_two: Array(len).fill(0),
                deduction_amount_two: Array(len).fill(0),
                withheld_deduction_amount_two: Array(len).fill(0),
            };
            return updated;
        });

        // Reset row seedha raw invoiceData baseline pe
        setFormData((prev) => {
            const updated = [...prev];
            const src = invoiceData[index] || {};
            updated[index] = {
                ...updated[index],
                actual_month_two: src.actual_month_two,
                current_invoice_amount_two: src.current_invoice_amount_two,
                actual_month_cumulative_total_two: src.actual_month_cumulative_total_two,
                actual_amount_cumulative_total: src.actual_amount_cumulative_total,
                actual_month: src.actual_month,
                invoice_amount: src.invoice_amount,
                actual_month_cumulative_total: src.actual_month_cumulative_total,
                cumulative_invoice_total: src.cumulative_invoice_total,
                actual_month_remaining: src.actual_month_remaining,
                remaining_amount: src.remaining_amount,
                deduction_amount: src.deduction_amount,
                deduction_reason: src.deduction_reason,
            };
            return updated;
        });

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`) || key.includes(`_${index}_`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    // Backend payload builder:
    // - "Both" → one object per row, scalar values (unchanged behavior)
    // - "Deduction" / "WithHeldDeduction" → one SEPARATE object per employee (sirf jahan actual deduction ho)
    useEffect(() => {
        const expanded = [];

        deductionformData.forEach((row) => {
            if (row.invoice_type === "null") return;

            if (row.invoice_type === "Both") {
                expanded.push({
                    deduction_reason: row.deduction_reason || "",
                    withheld_deduction_reason: row.withheld_deduction_reason || "",
                    invoice_type: row.invoice_type,
                    item_id: row.item_id,
                    invoice_id: row.invoice_id,
                    project: row.project,
                    related_item_data: "Employee",
                    deduction_month: row.deduction_month,
                    deduction_amount: row.deduction_amount,
                    withheld_deduction_amount: row.withheld_deduction_amount,
                });
                return;
            }

            const len = Math.max(
                (row.deduction_month_two || []).length,
                (row.deduction_amount_two || []).length,
                (row.withheld_deduction_amount_two || []).length
            );

            for (let empIndex = 0; empIndex < len; empIndex++) {
                const passedMonthEntered = row.passed_month_two?.[empIndex] !== "" && row.passed_month_two?.[empIndex] !== undefined;
                const passedAmountEntered = row.passed_amount_two?.[empIndex] !== "" && row.passed_amount_two?.[empIndex] !== undefined;
                if (!passedMonthEntered && !passedAmountEntered) continue; // skip employees with no input

                const dMonth = Number(row.deduction_month_two?.[empIndex] ?? 0);
                const dAmt = Number(
                    row.invoice_type === "WithHeldDeduction"
                        ? row.withheld_deduction_amount_two?.[empIndex] ?? 0
                        : row.deduction_amount_two?.[empIndex] ?? 0
                );
                if (dMonth === 0 && dAmt === 0) continue; // koi change nahi → deduction record nahi

                expanded.push({
                    deduction_reason: row.deduction_reason || "",
                    withheld_deduction_reason: row.withheld_deduction_reason || "",
                    invoice_type: row.invoice_type,
                    item_id: row.item_id,
                    invoice_id: row.invoice_id,
                    project: row.project,
                    related_item_data: "Employee",
                    deduction_month: row.deduction_month_two?.[empIndex] ?? 0,
                    deduction_amount: row.invoice_type === "Deduction" ? (row.deduction_amount_two?.[empIndex] ?? 0) : 0,
                    withheld_deduction_amount: row.invoice_type === "WithHeldDeduction" ? (row.withheld_deduction_amount_two?.[empIndex] ?? 0) : 0,
                });
            }
        });

        setFinalDeductionFormData(expanded);
    }, [deductionformData]);

    console.log("Final Deduction Form Data:", finalDeductionFormData);
    console.log("Deduction Form Data:", formData);

    // Raised (read-only) + Passed (input) + auto Deduction, one block per employee.
    const renderRaisedPassedRows = (index) => {
        const raisedMonths = invoiceData[index]?.actual_month_two || [];
        const raisedAmounts = invoiceData[index]?.current_invoice_amount_two || [];
        const empNames = invoiceData[index]?.boq_name_employee_two || [];
        const row = deductionformData[index] || {};
        const passedMonths = row.passed_month_two || [];
        const passedAmounts = row.passed_amount_two || [];
        const deductionMonths = row.deduction_month_two || [];
        const deductionAmounts = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount_two || [] : row.deduction_amount_two || [];

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th rowSpan={2} style={thStyle}>Employee</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Month</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {raisedMonths.map((_, empIndex) => (
                        <tr
                            key={empIndex}
                            style={{
                                background: empIndex % 2 === 0 ? '#ffffff' : '#fafbfc',
                                borderTop: '1px solid #f1f5f9',
                            }}
                        >
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#1e293b' }}>
                                {empNames[empIndex] || `Emp ${empIndex + 1}`}
                            </td>

                            {/* Raised — read-only */}
                            <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>{raisedMonths[empIndex]}</td>
                            <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmounts[empIndex]}</td>

                            {/* Passed — inputs (saved values se prefilled) */}
                            <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                                <input
                                    type="number"
                                    min="0"
                                    value={passedMonths[empIndex] ?? ""}
                                    onChange={(e) => handlePassedChange(index, empIndex, "month", e.target.value)}
                                    className={`modern-select ${errors[`month_${index}_${empIndex}`] ? "error" : ""}`}
                                    style={{ width: '70px', fontSize: '12px' }}
                                />
                                {errors[`month_${index}_${empIndex}`] && (
                                    <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}_${empIndex}`]}</div>
                                )}
                            </td>
                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                <input
                                    type="number"
                                    min="0"
                                    value={passedAmounts[empIndex] ?? ""}
                                    onChange={(e) => handlePassedChange(index, empIndex, "amount", e.target.value)}
                                    className={`modern-select ${errors[`amount_${index}_${empIndex}`] ? "error" : ""}`}
                                    style={{ width: '70px', fontSize: '12px' }}
                                />
                                {errors[`amount_${index}_${empIndex}`] && (
                                    <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}_${empIndex}`]}</div>
                                )}
                            </td>

                            {/* Deduction — auto-computed */}
                            <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                                {deductionMonths[empIndex] ?? 0}
                            </td>
                            <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                                ₹{deductionAmounts[empIndex] ?? 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Update employee BOQ" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add Employee Deductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>Employee Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per employee</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Designation</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.designation_name}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>{entry.professional_type}</div>
                                                    {entry?.boq_name_employee_two?.map((val, subIndex) => (
                                                        <div key={subIndex} style={{ fontSize: '11px', color: '#475569', marginTop: '2px' }}>{val}</div>
                                                    ))}
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Month</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRows(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRows(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// const UpdateTransportDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);


//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});
//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);





//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 boq_vehicle_description: item.boq_vehicle_description,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 no_of_vehicle: item?.no_of_vehicle,
//                 current_invoice_amount_two: item.current_invoice_amount_two,

//                 actual_amount_cumulative_total: item.actual_amount_cumulative_total,
//                 boq_name_employee_two: item.boq_name_employee_two,

//                 invoice_amount: item.invoice_amount,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 remaining_amount: item.remaining_amount,
//                 actual_month: item.actual_month,
//                 actual_month_cumulative_total_two: item.actual_month_cumulative_total_two,
//                 cumulative_invoice_total: item.cumulative_invoice_total,


//             }));

//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))

//             setDeductionFormData(initialDeductionData)

//             setFormData(initialData);
//         }
//     }, [invoiceData]);



//     console.log(formData, "FormData")




//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoicetransportationupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }

//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Month cannot exceed actual month"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = [...((invoiceData[index]?.actual_month_two) || [])];
//                 const currentInvoiceAmountTwo = [...(invoiceData[index]?.current_invoice_amount_two || [])];

//                 const prevMonthTotal = [...(invoiceData[index]?.actual_month_total_previous_two || [])];
//                 const prevInvoiceTotal = [...(invoiceData[index]?.previous_invoice_total_two || [])];

//                 const cumulativeMonth = [...(invoiceData[index]?.actual_month_cumulative_total_two || [])];
//                 const cumulativeAmount = [...(invoiceData[index]?.actual_amount_cumulative_total || [])];

//                 actualMonthTwo[0] = (
//                     Number(actualMonthTwo[0] || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 cumulativeMonth[0] = (
//                     Number(Number(actualMonthTwo[0] || 0) + Number(prevMonthTotal[0] || 0)).toFixed(2)
//                 )

//                 console.log("actualMonthTwo", actualMonthTwo)



//                 currentInvoiceAmountTwo[0] =
//                     Number(currentInvoiceAmountTwo[0] || 0) -
//                     (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 cumulativeAmount[0] =
//                     Number(Number(prevInvoiceTotal[0] || 0) + Number(currentInvoiceAmountTwo[0] || 0)).toFixed(2);

//                 // calculate sums
//                 const actualMonthsum = actualMonthTwo.reduce((a, b) => a + Number(b || 0), 0);
//                 const invoiceAmountSum = currentInvoiceAmountTwo.reduce((a, b) => a + Number(b || 0), 0);
//                 const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
//                 const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month_two: actualMonthTwo,
//                     actual_month: actualMonthsum,
//                     current_invoice_amount_two: currentInvoiceAmountTwo,
//                     actual_month_cumulative_total_two: cumulativeMonth,
//                     actual_amount_cumulative_total: cumulativeAmount,
//                     invoice_amount: invoiceAmountSum,
//                     actual_month_cumulative_total: cumulativeMonthSum,
//                     cumulative_invoice_total: cumulativeAmountSum,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])






//     return (
//         <>
//             <button title="Add Transportation Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add TransportationDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add Transportation Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <ModalBody>

//                             <div className='table-box scroll-container-table'>

//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>

//                                             <th className="table-heading-text text-center">Vehicle Description <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Number of Vehicle <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Month  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>

//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Month</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>


//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.boq_vehicle_description}</td>
//                                                 <td className="align-left width-5vw">{entry.no_of_vehicle}</td>
//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }


//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </ModalBody>
//                     </Modal>
//             }
//         </>


//     )
// }


const UpdateTransportDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the per-vehicle Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, single value for the whole row
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — per-vehicle arrays, same indexing
        // as invoiceData[index].actual_month_two / current_invoice_amount_two / boq_name_employee_two
        passed_month_two: [],
        passed_amount_two: [],
        deduction_month_two: [],       // raised_month[i] - passed_month[i]
        deduction_amount_two: [],      // used when invoice_type === "Deduction"
        withheld_deduction_amount_two: [], // used when invoice_type === "WithHeldDeduction"
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                boq_vehicle_description: item.boq_vehicle_description,
                no_of_vehicle: item?.no_of_vehicle,
                current_invoice_amount_two: item.current_invoice_amount_two,
                actual_month_two: item.actual_month_two,
                current_invoice_amount_twoo: item.current_invoice_amount_two,
                actual_amounttt_cumulative_total_two: item.actual_amount_cumulative_total,
                actual_amount_cumulative_total: item.actual_amount_cumulative_total,
                boq_name_employee_two: item.boq_name_employee_two,
                actual_month: item.actual_month,
                invoice_amount: item.invoice_amount,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                remaining_amount: item.remaining_amount,
                previous_invoice_total_two: item.previous_invoice_total_two,
                actual_month_total_previous_two: item.actual_month_total_previous_two,
                actual_month_cumulative_total_two: item.actual_month_cumulative_total_two,
                cumulative_invoice_total: item.cumulative_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => {
                const len = (item.actual_month_two || []).length;
                return {
                    deduction_reason: "",
                    withheld_deduction_reason: "",
                    invoice_type: "null",
                    item_id: item.id,
                    invoice_id: item.invoice,
                    project: item.project,

                    deduction_month: "",
                    deduction_amount: "",
                    withheld_deduction_amount: "",

                    passed_month_two: Array(len).fill(""),
                    passed_amount_two: Array(len).fill(""),
                    deduction_month_two: Array(len).fill(0),
                    deduction_amount_two: Array(len).fill(0),
                    withheld_deduction_amount_two: Array(len).fill(0),
                };
            });

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasAnyPassed = (row.passed_month_two || []).some((v) => v !== "" && v !== undefined)
                    || (row.passed_amount_two || []).some((v) => v !== "" && v !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasAnyPassed) newErrors[`deduction_month_${index}`] = "Enter Passed values for at least one vehicle";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasAnyPassed = (row.passed_month_two || []).some((v) => v !== "" && v !== undefined)
                    || (row.passed_amount_two || []).some((v) => v !== "" && v !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasAnyPassed) newErrors[`deduction_month_${index}`] = "Enter Passed values for at least one vehicle";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoicetransportationupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // ---- "Both" path — unchanged, single value affecting index 0 ----
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];
            const actualMonthTwo = [...((invoiceData[index]?.actual_month_two) || [])];
            const currentInvoiceAmountTwo = [...(invoiceData[index]?.current_invoice_amount_two || [])];
            const prevMonthTotal = [...(updatedForm[index]?.actual_month_total_previous_two || [])];
            const prevInvoiceTotal = [...(updatedForm[index]?.previous_invoice_total_two || [])];
            const cumulativeMonth = [...(updatedForm[index]?.actual_month_cumulative_total_two || [])];
            const cumulativeAmount = [...(updatedForm[index]?.actual_amount_cumulative_total || [])];

            actualMonthTwo[0] = (Number(actualMonthTwo[0] || 0).toFixed(2) - Number(deductionMonth || 0).toFixed(2));
            currentInvoiceAmountTwo[0] = Number(currentInvoiceAmountTwo[0] || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            cumulativeMonth[0] = Number(prevMonthTotal[0] || 0) + Number(actualMonthTwo[0] || 0);
            cumulativeAmount[0] = Number(prevInvoiceTotal[0] || 0) + Number(currentInvoiceAmountTwo[0] || 0);

            const actualMonthsum = actualMonthTwo.reduce((a, b) => a + Number(Number(b).toFixed(2) || 0), 0);
            const invoiceAmountSum = currentInvoiceAmountTwo.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month_two: actualMonthTwo,
                actual_month: actualMonthsum,
                current_invoice_amount_two: currentInvoiceAmountTwo,
                actual_month_cumulative_total_two: cumulativeMonth,
                actual_amount_cumulative_total: cumulativeAmount,
                invoice_amount: invoiceAmountSum,
                actual_month_cumulative_total: cumulativeMonthSum,
                cumulative_invoice_total: cumulativeAmountSum,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Month cannot exceed actual month" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — per-vehicle Raised/Passed ----

    // Absolute recompute for one vehicle index (vehIndex) inside a row (index).
    // Writes into formData[index].deduction_amount / deduction_reason arrays at the same
    // vehIndex — deduction_amount holds the amount, deduction_reason holds the MONTH value
    // (per instruction), not text.
    const applyToFormDataPerEmployee = (
        index,
        vehIndex,
        deductionMonth,
        deductionAmount,
        totalDeductionMonth = 0,
        totalDeductionAmount = 0
    ) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];
            const prevMonthTotal = [...(invoiceData[index]?.actual_month_total_previous_two || [])];
            const prevInvoiceTotal = [...(invoiceData[index]?.previous_invoice_total_two || [])];

            const deductionAmountArr = [...(updatedForm[index]?.deduction_amount || [])];
            const deductionReasonArr = [...(updatedForm[index]?.deduction_reason || [])];
            deductionAmountArr[vehIndex] = deductionAmount || 0;
            deductionReasonArr[vehIndex] = deductionMonth || 0;

            const actualMonthSum = deductionReasonArr.reduce((a, b) => a + Number(b || 0), 0);
            const invoiceAmountSum = deductionAmountArr.reduce((a, b) => a + Number(b || 0), 0);

            const cumulativeMonth = deductionReasonArr.map((m, i) =>
                i < prevMonthTotal.length ? Number(prevMonthTotal[i] || 0) + Number(m || 0) : Number(m || 0)
            );
            const cumulativeAmount = deductionAmountArr.map((a, i) =>
                i < prevInvoiceTotal.length ? Number(prevInvoiceTotal[i] || 0) + Number(a || 0) : Number(a || 0)
            );

            const cumulativeMonthSum = cumulativeMonth.reduce((a, b) => a + Number(b || 0), 0);
            const cumulativeAmountSum = cumulativeAmount.reduce((a, b) => a + Number(b || 0), 0);

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month_two: deductionReasonArr,
                actual_month: actualMonthSum,
                current_invoice_amount_two: deductionAmountArr,
                actual_month_cumulative_total_two: cumulativeMonth,
                actual_amount_cumulative_total: cumulativeAmount,
                invoice_amount: invoiceAmountSum,
                actual_month_cumulative_total: cumulativeMonthSum,
                cumulative_invoice_total: cumulativeAmountSum,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining || 0) + Number(totalDeductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount || 0) + Number(totalDeductionAmount || 0),
                deduction_amount: deductionAmountArr,
                deduction_reason: deductionReasonArr,
            };

            return updatedForm;
        });
    };
    // Passed input change for one vehicle (vehIndex) within row (index).
    // deduction_month_two[vehIndex]      = raised_month[vehIndex]  - passed_month[vehIndex]
    // deduction_amount_two[vehIndex]     = raised_amount[vehIndex] - passed_amount[vehIndex]  (type: Deduction)
    // withheld_deduction_amount_two[vehIndex] = raised_amount[vehIndex] - passed_amount[vehIndex]  (type: WithHeldDeduction)
    const handlePassedChange = (index, vehIndex, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}_${vehIndex}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month_two?.[vehIndex] || 0);
        const raisedAmount = Number(invoiceData[index]?.current_invoice_amount_two?.[vehIndex] || 0);

        const passedMonthTwo = [...(row.passed_month_two || [])];
        const passedAmountTwo = [...(row.passed_amount_two || [])];
        if (field === "month") passedMonthTwo[vehIndex] = value;
        else passedAmountTwo[vehIndex] = value;

        const passedMonth = Number(passedMonthTwo[vehIndex] || 0);
        const passedAmount = Number(passedAmountTwo[vehIndex] || 0);

        if (field === "month" && passedMonth > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}_${vehIndex}`]: "Passed month cannot exceed raised month" }));
            return;
        }
        if (field === "amount" && passedAmount > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}_${vehIndex}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}_${vehIndex}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonth).toFixed(2));
        const deductionAmount = raisedAmount - passedAmount;

        const deductionMonthTwo = [...(row.deduction_month_two || [])];
        const deductionAmountTwo = [...(row.deduction_amount_two || [])];
        const withheldAmountTwo = [...(row.withheld_deduction_amount_two || [])];
        deductionMonthTwo[vehIndex] = deductionMonth;
        if (row.invoice_type === "WithHeldDeduction") withheldAmountTwo[vehIndex] = deductionAmount;
        else deductionAmountTwo[vehIndex] = deductionAmount;

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                passed_month_two: passedMonthTwo,
                passed_amount_two: passedAmountTwo,
                deduction_month_two: deductionMonthTwo,
                deduction_amount_two: deductionAmountTwo,
                withheld_deduction_amount_two: withheldAmountTwo,
            };
            return updated;
        });

        // FRESH totals (state se nahi, abhi bane arrays se)
        const totalDeductionMonth = deductionMonthTwo.reduce((a, b) => a + Number(b || 0), 0);
        const totalDeductionAmount = (row.invoice_type === "WithHeldDeduction" ? withheldAmountTwo : deductionAmountTwo)
            .reduce((a, b) => a + Number(b || 0), 0);

        applyToFormDataPerEmployee(index, vehIndex, passedMonth, passedAmount, totalDeductionMonth, totalDeductionAmount);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";
        const len = (invoiceData[index]?.actual_month_two || []).length;

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month_two: Array(len).fill(""),
                passed_amount_two: Array(len).fill(""),
                deduction_month_two: Array(len).fill(0),
                deduction_amount_two: Array(len).fill(0),
                withheld_deduction_amount_two: Array(len).fill(0),
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);
        for (let vehIndex = 0; vehIndex < len; vehIndex++) {
            applyToFormDataPerEmployee(index, vehIndex, 0, 0);
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`) || key.includes(`_${index}_`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    // Backend payload builder:
    // - "Both" → one object per row, scalar values (unchanged behavior)
    // - "Deduction" / "WithHeldDeduction" → one SEPARATE object per vehicle
    //   (same item_id/invoice_id/project, scalar deduction_month/deduction_amount —
    //   NOT arrays). If a row has 2 vehicles with passed values entered, this produces 2 objects.
    useEffect(() => {
        const expanded = [];

        deductionformData.forEach((row) => {
            if (row.invoice_type === "null") return;

            if (row.invoice_type === "Both") {
                expanded.push({
                    deduction_reason: row.deduction_reason || "",
                    withheld_deduction_reason: row.withheld_deduction_reason || "",
                    invoice_type: row.invoice_type,
                    item_id: row.item_id,
                    invoice_id: row.invoice_id,
                    project: row.project,
                    deduction_month: row.deduction_month,
                    deduction_amount: row.deduction_amount,
                    withheld_deduction_amount: row.withheld_deduction_amount,
                });
                return;
            }

            const len = Math.max(
                (row.deduction_month_two || []).length,
                (row.deduction_amount_two || []).length,
                (row.withheld_deduction_amount_two || []).length
            );

            for (let vehIndex = 0; vehIndex < len; vehIndex++) {
                const passedMonthEntered = row.passed_month_two?.[vehIndex] !== "" && row.passed_month_two?.[vehIndex] !== undefined;
                const passedAmountEntered = row.passed_amount_two?.[vehIndex] !== "" && row.passed_amount_two?.[vehIndex] !== undefined;
                if (!passedMonthEntered && !passedAmountEntered) continue; // skip vehicles with no input

                expanded.push({
                    deduction_reason: row.deduction_reason || "",
                    withheld_deduction_reason: row.withheld_deduction_reason || "",
                    invoice_type: row.invoice_type,
                    item_id: row.item_id,
                    invoice_id: row.invoice_id,
                    project: row.project,
                    deduction_month: row.deduction_month_two?.[vehIndex] ?? 0,
                    deduction_amount: row.invoice_type === "Deduction" ? (row.deduction_amount_two?.[vehIndex] ?? 0) : 0,
                    withheld_deduction_amount: row.invoice_type === "WithHeldDeduction" ? (row.withheld_deduction_amount_two?.[vehIndex] ?? 0) : 0,
                });
            }
        });

        setFinalDeductionFormData(expanded);
    }, [deductionformData]);


    console.log("finalDeductionFormData", finalDeductionFormData)

    // Raised (read-only) + Passed (input) + auto Deduction, one block per vehicle.
    const renderRaisedPassedRows = (index) => {
        const raisedMonths = invoiceData[index]?.actual_month_two || [];
        const raisedAmounts = invoiceData[index]?.current_invoice_amount_two || [];
        const vehNames = invoiceData[index]?.boq_name_employee_two || [];
        const row = deductionformData[index] || {};
        const passedMonths = row.passed_month_two || [];
        const passedAmounts = row.passed_amount_two || [];
        const deductionMonths = row.deduction_month_two || [];
        const deductionAmounts = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount_two || [] : row.deduction_amount_two || [];

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th rowSpan={2} style={thStyle}>Vehicle</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Month</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {raisedMonths.map((_, vehIndex) => (
                        <tr
                            key={vehIndex}
                            style={{
                                background: vehIndex % 2 === 0 ? '#ffffff' : '#fafbfc',
                                borderTop: '1px solid #f1f5f9',
                            }}
                        >
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#1e293b' }}>
                                {vehNames[vehIndex] || `Vehicle ${vehIndex + 1}`}
                            </td>

                            {/* Raised — read-only */}
                            <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>{raisedMonths[vehIndex]}</td>
                            <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmounts[vehIndex]}</td>

                            {/* Passed — inputs */}
                            <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                                <input
                                    type="number"
                                    min="0"
                                    value={passedMonths[vehIndex] ?? ""}
                                    onChange={(e) => handlePassedChange(index, vehIndex, "month", e.target.value)}
                                    className={`modern-select ${errors[`month_${index}_${vehIndex}`] ? "error" : ""}`}
                                    style={{ width: '70px', fontSize: '12px' }}
                                />
                                {errors[`month_${index}_${vehIndex}`] && (
                                    <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}_${vehIndex}`]}</div>
                                )}
                            </td>
                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                                <input
                                    type="number"
                                    min="0"
                                    value={passedAmounts[vehIndex] ?? ""}
                                    onChange={(e) => handlePassedChange(index, vehIndex, "amount", e.target.value)}
                                    className={`modern-select ${errors[`amount_${index}_${vehIndex}`] ? "error" : ""}`}
                                    style={{ width: '70px', fontSize: '12px' }}
                                />
                                {errors[`amount_${index}_${vehIndex}`] && (
                                    <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}_${vehIndex}`]}</div>
                                )}
                            </td>

                            {/* Deduction — auto-computed */}
                            <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                                {deductionMonths[vehIndex] ?? 0}
                            </td>
                            <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                                ₹{deductionAmounts[vehIndex] ?? 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add Transportation Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add Transportation Deductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>Transportation Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per vehicle</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Vehicle Description</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.boq_vehicle_description}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>{entry.no_of_vehicle} vehicle(s)</div>
                                                    {entry?.boq_name_employee_two?.map((val, subIndex) => (
                                                        <div key={subIndex} style={{ fontSize: '11px', color: '#475569', marginTop: '2px' }}>{val}</div>
                                                    ))}
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Month</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRows(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRows(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// const UpdateTravelDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});
//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);





//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 boq_trips: item.boq_trips,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 invoice_amount: item.invoice_amount,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 remaining_amount: item.remaining_amount,
//                 actual_trip: item.actual_trip,
//                 cumulative_invoice_total: item.cumulative_invoice_total,




//             }));

//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))

//             setDeductionFormData(initialDeductionData)
//             setFormData(initialData);
//         }
//     }, [invoiceData]);


//     console.log("formData invoice")
//     console.log(invoiceData)
//     console.log("formData deductions")
//     console.log(formData)


//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoicedutytravelupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_trip || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Trip cannot exceed actual Trip"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = ((invoiceData[index]?.actual_trip) || 0)
//                 const currentInvoiceAmountTwo = (invoiceData[index]?.invoice_amount || 0)

//                 const prevMonthTotal = (invoiceData[index]?.actual_month_total_previous || 0)
//                 const prevInvoiceTotal = (invoiceData[index]?.previous_invoice_total || 0)

//                 const cumulativeMonth = (invoiceData[index]?.actual_month_cumulative_total || 0)
//                 const cumulativeAmount = (invoiceData[index]?.cumulative_invoice_total || 0)

//                 const actualMonthTwoo = (
//                     Number(actualMonthTwo || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 const cumulativeMonthh = (
//                     Number(Number(actualMonthTwoo || 0) + Number(prevMonthTotal || 0)).toFixed(2)
//                 )




//                 const currentInvoiceAmountTwoo =
//                     Number(currentInvoiceAmountTwo || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 const cumulativeAmountt =
//                     Number(Number(prevInvoiceTotal || 0) + Number(currentInvoiceAmountTwoo || 0)).toFixed(2);

//                 // calculate sums

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_trip: actualMonthTwoo,
//                     invoice_amount: currentInvoiceAmountTwoo,
//                     actual_month_cumulative_total: cumulativeMonthh,
//                     cumulative_invoice_total: cumulativeAmountt,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])



//     console.log(formData, "deductionformData")


//     return (
//         <>
//             <button title="Add DutyTravel Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add DutyTravelDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add DutyTravel Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <ModalBody>

//                             <div className='table-box scroll-container-table'>
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>

//                                             <th className="table-heading-text text-center">Trip Description <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Trip  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>

//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Trip</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>


//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.boq_trips}</td>
//                                                 <td className="align-left width-5vw">{entry.actual_trip}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }



//                                                 {/* Rate column (unchanged) */}

//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </ModalBody>
//                     </Modal>
//             }
//         </>


//     )
// }

const UpdateTravelDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, manual entry
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — NEW: Raised/Passed → auto Deduction.
        // Duty-travel line items are scalar (no per-employee/vehicle sub-items), so
        // these are single values per row, not arrays.
        passed_trip: "",
        passed_amount: "",
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                boq_trips: item.boq_trips,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                invoice_amount: item.invoice_amount,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                remaining_amount: item.remaining_amount,
                actual_trip: item.actual_trip,
                cumulative_invoice_total: item.cumulative_invoice_total,
                actual_month_total_previous: item.actual_month_total_previous,
                previous_invoice_total: item.previous_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => ({
                deduction_reason: "",
                withheld_deduction_reason: "",
                invoice_type: "null",
                item_id: item.id,
                invoice_id: item.invoice,
                project: item.project,

                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",

                passed_trip: "",
                passed_amount: "",
            }));

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Trip is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasPassed = (row.passed_trip !== "" && row.passed_trip !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Trip / Amount";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasPassed = (row.passed_trip !== "" && row.passed_trip !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Trip / Amount";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoicedutytravelupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // Shared cascade recompute for a row — scalar version (no arrays), used by
    // both the "Both" manual path and the "Deduction"/"WithHeldDeduction" passed path.
    const applyToFormData = (index, deductionTrip, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];

            const actualTrip = Number(invoiceData[index]?.actual_trip || 0);
            const currentInvoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);
            const prevMonthTotal = Number(invoiceData[index]?.actual_month_total_previous || 0);
            const prevInvoiceTotal = Number(invoiceData[index]?.previous_invoice_total || 0);

            const newActualTrip = Number((actualTrip - Number(deductionTrip || 0)).toFixed(2));
            const newInvoiceAmount = currentInvoiceAmount - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            const newCumulativeMonth = Number((prevMonthTotal + newActualTrip).toFixed(2));
            const newCumulativeAmount = Number((prevInvoiceTotal + newInvoiceAmount).toFixed(2));

            updatedForm[index] = {
                ...updatedForm[index],
                actual_trip: newActualTrip,
                invoice_amount: newInvoiceAmount,
                actual_month_cumulative_total: newCumulativeMonth,
                cumulative_invoice_total: newCumulativeAmount,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionTrip || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    // ---- "Both" path — unchanged, manual entry ----
    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualTrip = Number(invoiceData[index]?.actual_trip || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualTrip) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Trip cannot exceed actual Trip" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — NEW Raised/Passed → auto Deduction ----
    // deduction_month (trip)         = raised_trip   - passed_trip
    // deduction_amount               = raised_amount - passed_amount   (type: Deduction)
    // withheld_deduction_amount      = raised_amount - passed_amount   (type: WithHeldDeduction)
    const handlePassedChange = (index, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedTrip = Number(invoiceData[index]?.actual_trip || 0);
        const raisedAmount = Number(invoiceData[index]?.invoice_amount || 0);

        const passedTrip = field === "trip" ? value : (row.passed_trip ?? "");
        const passedAmount = field === "amount" ? value : (row.passed_amount ?? "");

        const passedTripNum = Number(passedTrip || 0);
        const passedAmountNum = Number(passedAmount || 0);

        if (field === "trip" && passedTripNum > raisedTrip) {
            setErrors((prev) => ({ ...prev, [`trip_${index}`]: "Passed trip cannot exceed raised trip" }));
            return;
        }
        if (field === "amount" && passedAmountNum > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionTrip = Number((raisedTrip - passedTripNum).toFixed(2));
        const deductionAmount = raisedAmount - passedAmountNum;

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            const updatedRow = {
                ...updated[index],
                passed_trip: passedTrip,
                passed_amount: passedAmount,
                deduction_month: deductionTrip,
            };
            if (updated[index]?.invoice_type === "WithHeldDeduction") {
                updatedRow.withheld_deduction_amount = deductionAmount;
            } else {
                updatedRow.deduction_amount = deductionAmount;
            }
            updated[index] = updatedRow;
            return updated;
        });

        const isWithheld = row.invoice_type === "WithHeldDeduction";
        applyToFormData(index, deductionTrip, isWithheld ? 0 : deductionAmount, isWithheld ? deductionAmount : 0);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_trip: "",
                passed_amount: "",
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    useEffect(() => {
        const filterNullData = deductionformData
            .filter(item => item.invoice_type !== "null")
            .map(({ passed_trip, passed_amount, ...rest }) => rest); // strip UI-only fields before submit
        if (filterNullData.length === 0) {
            setFinalDeductionFormData([]);
        } else {
            setFinalDeductionFormData(filterNullData);
        }
    }, [deductionformData]);

    // Raised (read-only) + Passed (input) + auto Deduction — single row per invoice
    // line item (duty-travel entries don't have per-employee/vehicle sub-items).
    const renderRaisedPassedRow = (index) => {
        const raisedTrip = invoiceData[index]?.actual_trip;
        const raisedAmount = invoiceData[index]?.invoice_amount;
        const row = deductionformData[index] || {};
        const passedTrip = row.passed_trip;
        const passedAmount = row.passed_amount;
        const deductionTrip = row.deduction_month;
        const deductionAmount = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount : row.deduction_amount;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={thSubStyle}>Trip</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Trip</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Trip</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* Raised — read-only */}
                        <td style={{ ...tdStyle, textAlign: 'center' }}>{raisedTrip}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmount}</td>

                        {/* Passed — inputs */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedTrip ?? ""}
                                onChange={(e) => handlePassedChange(index, "trip", e.target.value)}
                                className={`modern-select ${errors[`trip_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`trip_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`trip_${index}`]}</div>
                            )}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedAmount ?? ""}
                                onChange={(e) => handlePassedChange(index, "amount", e.target.value)}
                                className={`modern-select ${errors[`amount_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`amount_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}`]}</div>
                            )}
                        </td>

                        {/* Deduction — auto-computed */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            {deductionTrip || 0}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            ₹{deductionAmount || 0}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add DutyTravel Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add DutyTravel Deductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>DutyTravel Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per trip</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Trip Description</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.boq_trips}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>Raised trip: {entry.actual_trip}</div>
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Trip</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_trip}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};
// const UpdateRentDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);


//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});

//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);




//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 invoice_amount: item.invoice_amount,
//                 remaining_amount: item.remaining_amount,
//                 cumulative_invoice_total: item.cumulative_invoice_total,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 actual_month: item.actual_month,


//             }));

//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))
//             setDeductionFormData(initialDeductionData)

//             setFormData(initialData);
//         }
//     }, [invoiceData]);


//     console.log("formData invoice")
//     console.log(invoiceData)
//     console.log("formData deductions")
//     console.log(formData)
//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => {
//             const newFields = [...prevFormData];
//             newFields[index] = {
//                 ...newFields[index],
//                 [name]: value,
//             };
//             return newFields;
//         });
//     }

//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoiceofficerentupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Month cannot exceed actual Month"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = ((invoiceData[index]?.actual_month) || 0)
//                 const currentInvoiceAmountTwo = (invoiceData[index]?.invoice_amount || 0)

//                 const prevMonthTotal = (invoiceData[index]?.actual_month_total_previous || 0)
//                 const prevInvoiceTotal = (invoiceData[index]?.previous_invoice_total || 0)

//                 const cumulativeMonth = (invoiceData[index]?.actual_month_cumulative_total || 0)
//                 const cumulativeAmount = (invoiceData[index]?.cumulative_invoice_total || 0)

//                 const actualMonthTwoo = (
//                     Number(actualMonthTwo || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 const cumulativeMonthh = (
//                     Number(Number(actualMonthTwoo || 0) + Number(prevMonthTotal || 0)).toFixed(2)
//                 )




//                 const currentInvoiceAmountTwoo =
//                     Number(currentInvoiceAmountTwo || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 const cumulativeAmountt =
//                     Number(Number(prevInvoiceTotal || 0) + Number(currentInvoiceAmountTwoo || 0)).toFixed(2);

//                 // calculate sums

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month: actualMonthTwoo,
//                     invoice_amount: currentInvoiceAmountTwoo,
//                     actual_month_cumulative_total: cumulativeMonthh,
//                     cumulative_invoice_total: cumulativeAmountt,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])





//     return (
//         <>
//             <button title="Add OfficeRent Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add OfficeRentDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add OfficeRent Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <Modal.Body>

//                             <div className='table-box scroll-container-table'>
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>
//                                             <th className="table-heading-text text-center">Month Raised  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>
//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Month</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>
//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>


//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }


//                                                 {/* Rate column (unchanged) */}

//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </Modal.Body>
//                     </Modal>
//             }
//         </>


//     )
// }

const UpdateRentDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, manual entry
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — NEW: Raised/Passed → auto Deduction.
        // Office-rent line items are scalar (no per-employee/vehicle sub-items), so
        // these are single values per row, not arrays.
        passed_month: "",
        passed_amount: "",
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                invoice_amount: item.invoice_amount,
                remaining_amount: item.remaining_amount,
                cumulative_invoice_total: item.cumulative_invoice_total,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                actual_month: item.actual_month,
                actual_month_total_previous: item.actual_month_total_previous,
                previous_invoice_total: item.previous_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => ({
                deduction_reason: "",
                withheld_deduction_reason: "",
                invoice_type: "null",
                item_id: item.id,
                invoice_id: item.invoice,
                project: item.project,

                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",

                passed_month: "",
                passed_amount: "",
            }));

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoiceofficerentupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // Shared cascade recompute for a row — scalar version (no arrays), used by
    // both the "Both" manual path and the "Deduction"/"WithHeldDeduction" passed path.
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];

            const actualMonth = Number(invoiceData[index]?.actual_month || 0);
            const currentInvoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);
            const prevMonthTotal = Number(invoiceData[index]?.actual_month_total_previous || 0);
            const prevInvoiceTotal = Number(invoiceData[index]?.previous_invoice_total || 0);

            const newActualMonth = Number((actualMonth - Number(deductionMonth || 0)).toFixed(2));
            const newInvoiceAmount = currentInvoiceAmount - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            const newCumulativeMonth = Number((prevMonthTotal + newActualMonth).toFixed(2));
            const newCumulativeAmount = Number((prevInvoiceTotal + newInvoiceAmount).toFixed(2));

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month: newActualMonth,
                invoice_amount: newInvoiceAmount,
                actual_month_cumulative_total: newCumulativeMonth,
                cumulative_invoice_total: newCumulativeAmount,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    // ---- "Both" path — unchanged, manual entry ----
    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0).toFixed(2);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Month cannot exceed actual Month" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — NEW Raised/Passed → auto Deduction ----
    // deduction_month             = raised_month  - passed_month
    // deduction_amount            = raised_amount - passed_amount   (type: Deduction)
    // withheld_deduction_amount   = raised_amount - passed_amount   (type: WithHeldDeduction)
    const handlePassedChange = (index, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month || 0);
        const raisedAmount = Number(invoiceData[index]?.invoice_amount || 0);

        const passedMonth = field === "month" ? value : (row.passed_month ?? "");
        const passedAmount = field === "amount" ? value : (row.passed_amount ?? "");

        const passedMonthNum = Number(passedMonth || 0);
        const passedAmountNum = Number(passedAmount || 0);

        if (field === "month" && passedMonthNum > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}`]: "Passed month cannot exceed raised month" }));
            return;
        }
        if (field === "amount" && passedAmountNum > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonthNum).toFixed(2));
        const deductionAmount = raisedAmount - passedAmountNum;

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            const updatedRow = {
                ...updated[index],
                passed_month: passedMonth,
                passed_amount: passedAmount,
                deduction_month: deductionMonth,
            };
            if (updated[index]?.invoice_type === "WithHeldDeduction") {
                updatedRow.withheld_deduction_amount = deductionAmount;
            } else {
                updatedRow.deduction_amount = deductionAmount;
            }
            updated[index] = updatedRow;
            return updated;
        });

        const isWithheld = row.invoice_type === "WithHeldDeduction";
        applyToFormData(index, deductionMonth, isWithheld ? 0 : deductionAmount, isWithheld ? deductionAmount : 0);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month: "",
                passed_amount: "",
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    useEffect(() => {
        const filterNullData = deductionformData
            .filter(item => item.invoice_type !== "null")
            .map(({ passed_month, passed_amount, ...rest }) => rest); // strip UI-only fields before submit
        if (filterNullData.length === 0) {
            setFinalDeductionFormData([]);
        } else {
            setFinalDeductionFormData(filterNullData);
        }
    }, [deductionformData]);

    // Raised (read-only) + Passed (input) + auto Deduction — single row per invoice
    // line item (office-rent entries don't have per-employee/vehicle sub-items).
    const renderRaisedPassedRow = (index) => {
        const raisedMonth = invoiceData[index]?.actual_month;
        const raisedAmount = invoiceData[index]?.invoice_amount;
        const row = deductionformData[index] || {};
        const passedMonth = row.passed_month;
        const passedAmount = row.passed_amount;
        const deductionMonth = row.deduction_month;
        const deductionAmount = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount : row.deduction_amount;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={thSubStyle}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Month</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* Raised — read-only */}
                        <td style={{ ...tdStyle, textAlign: 'center' }}>{raisedMonth}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmount}</td>

                        {/* Passed — inputs */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedMonth ?? ""}
                                onChange={(e) => handlePassedChange(index, "month", e.target.value)}
                                className={`modern-select ${errors[`month_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`month_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}`]}</div>
                            )}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedAmount ?? ""}
                                onChange={(e) => handlePassedChange(index, "amount", e.target.value)}
                                className={`modern-select ${errors[`amount_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`amount_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}`]}</div>
                            )}
                        </td>

                        {/* Deduction — auto-computed */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            {deductionMonth || 0}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            ₹{deductionAmount || 0}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add OfficeRent Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add OfficeRent Deductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>OfficeRent Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per month</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Month Raised</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.actual_month}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>₹{entry.invoice_amount}</div>
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Month</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// const UpdateSuppliesDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);


//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});
//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);





//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 boq_item: item.boq_item,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,


//                 invoice_amount: item.invoice_amount,
//                 remaining_amount: item.remaining_amount,
//                 cumulative_invoice_total: item.cumulative_invoice_total,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 actual_month: item.actual_month,

//             }));
//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))
//             setDeductionFormData(initialDeductionData)

//             setFormData(initialData);
//         }
//     }, [invoiceData]);


//     console.log("formData invoice")
//     console.log(invoiceData)
//     console.log("formData deductions")
//     console.log(formData)
//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => {
//             const newFields = [...prevFormData];
//             newFields[index] = {
//                 ...newFields[index],
//                 [name]: value,
//             };
//             return newFields;
//         });
//     }

//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoiceofficesuppliesupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Month cannot exceed actual Month"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = ((invoiceData[index]?.actual_month) || 0)
//                 const currentInvoiceAmountTwo = (invoiceData[index]?.invoice_amount || 0)

//                 const prevMonthTotal = (invoiceData[index]?.actual_month_total_previous || 0)
//                 const prevInvoiceTotal = (invoiceData[index]?.previous_invoice_total || 0)

//                 const cumulativeMonth = (invoiceData[index]?.actual_month_cumulative_total || 0)
//                 const cumulativeAmount = (invoiceData[index]?.cumulative_invoice_total || 0)

//                 const actualMonthTwoo = (
//                     Number(actualMonthTwo || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 const cumulativeMonthh = (
//                     Number(Number(actualMonthTwoo || 0) + Number(prevMonthTotal || 0)).toFixed(2)
//                 )




//                 const currentInvoiceAmountTwoo =
//                     Number(currentInvoiceAmountTwo || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 const cumulativeAmountt =
//                     Number(Number(prevInvoiceTotal || 0) + Number(currentInvoiceAmountTwoo || 0)).toFixed(2);

//                 // calculate sums

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month: actualMonthTwoo,
//                     invoice_amount: currentInvoiceAmountTwoo,
//                     actual_month_cumulative_total: cumulativeMonthh,
//                     cumulative_invoice_total: cumulativeAmountt,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };
//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])




//     return (
//         <>
//             <button title="Add OfficeSupplies Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add OfficeSuppliesDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add OfficeSupplies Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <Modal.Body>

//                             <div className='table-box scroll-container-table'>
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>

//                                             <th className="table-heading-text text-center">Item Description <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Month Raised  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>
//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Month</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>

//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.boq_item}</td>
//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }
//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </Modal.Body>
//                     </Modal>
//             }
//         </>


//     )
// }

const UpdateSuppliesDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, manual entry
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — NEW: Raised/Passed → auto Deduction.
        // Office-supplies line items are scalar (no per-employee/vehicle sub-items), so
        // these are single values per row, not arrays.
        passed_month: "",
        passed_amount: "",
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                boq_item: item.boq_item,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                invoice_amount: item.invoice_amount,
                remaining_amount: item.remaining_amount,
                cumulative_invoice_total: item.cumulative_invoice_total,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                actual_month: item.actual_month,
                actual_month_total_previous: item.actual_month_total_previous,
                previous_invoice_total: item.previous_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => ({
                deduction_reason: "",
                withheld_deduction_reason: "",
                invoice_type: "null",
                item_id: item.id,
                invoice_id: item.invoice,
                project: item.project,

                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",

                passed_month: "",
                passed_amount: "",
            }));

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoiceofficesuppliesupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // Shared cascade recompute for a row — scalar version (no arrays), used by
    // both the "Both" manual path and the "Deduction"/"WithHeldDeduction" passed path.
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];

            const actualMonth = Number(invoiceData[index]?.actual_month || 0);
            const currentInvoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);
            const prevMonthTotal = Number(invoiceData[index]?.actual_month_total_previous || 0);
            const prevInvoiceTotal = Number(invoiceData[index]?.previous_invoice_total || 0);

            const newActualMonth = Number((actualMonth - Number(deductionMonth || 0)).toFixed(2));
            const newInvoiceAmount = currentInvoiceAmount - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            const newCumulativeMonth = Number((prevMonthTotal + newActualMonth).toFixed(2));
            const newCumulativeAmount = Number((prevInvoiceTotal + newInvoiceAmount).toFixed(2));

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month: newActualMonth,
                invoice_amount: newInvoiceAmount,
                actual_month_cumulative_total: newCumulativeMonth,
                cumulative_invoice_total: newCumulativeAmount,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    // ---- "Both" path — unchanged, manual entry ----
    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0).toFixed(2);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0).toFixed(2);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Month cannot exceed actual Month" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — NEW Raised/Passed → auto Deduction ----
    // deduction_month             = raised_month  - passed_month
    // deduction_amount            = raised_amount - passed_amount   (type: Deduction)
    // withheld_deduction_amount   = raised_amount - passed_amount   (type: WithHeldDeduction)
    const handlePassedChange = (index, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month || 0);
        const raisedAmount = Number(invoiceData[index]?.invoice_amount || 0);

        const passedMonth = field === "month" ? value : (row.passed_month ?? "");
        const passedAmount = field === "amount" ? value : (row.passed_amount ?? "");

        const passedMonthNum = Number(passedMonth || 0);
        const passedAmountNum = Number(passedAmount || 0);

        if (field === "month" && passedMonthNum > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}`]: "Passed month cannot exceed raised month" }));
            return;
        }
        if (field === "amount" && passedAmountNum > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonthNum).toFixed(2));
        const deductionAmount = Number(raisedAmount - passedAmountNum).toFixed(2);

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            const updatedRow = {
                ...updated[index],
                passed_month: passedMonth,
                passed_amount: passedAmount,
                deduction_month: deductionMonth,
            };
            if (updated[index]?.invoice_type === "WithHeldDeduction") {
                updatedRow.withheld_deduction_amount = deductionAmount;
            } else {
                updatedRow.deduction_amount = deductionAmount;
            }
            updated[index] = updatedRow;
            return updated;
        });

        const isWithheld = row.invoice_type === "WithHeldDeduction";
        applyToFormData(index, deductionMonth, isWithheld ? 0 : deductionAmount, isWithheld ? deductionAmount : 0);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month: "",
                passed_amount: "",
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    useEffect(() => {
        const filterNullData = deductionformData
            .filter(item => item.invoice_type !== "null")
            .map(({ passed_month, passed_amount, ...rest }) => rest); // strip UI-only fields before submit
        if (filterNullData.length === 0) {
            setFinalDeductionFormData([]);
        } else {
            setFinalDeductionFormData(filterNullData);
        }
    }, [deductionformData]);

    // Raised (read-only) + Passed (input) + auto Deduction — single row per invoice
    // line item (office-supplies entries don't have per-employee/vehicle sub-items).
    const renderRaisedPassedRow = (index) => {
        const raisedMonth = invoiceData[index]?.actual_month;
        const raisedAmount = invoiceData[index]?.invoice_amount;
        const row = deductionformData[index] || {};
        const passedMonth = row.passed_month;
        const passedAmount = row.passed_amount;
        const deductionMonth = row.deduction_month;
        const deductionAmount = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount : Number(row.deduction_amount).toFixed(2);

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={thSubStyle}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Month</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* Raised — read-only */}
                        <td style={{ ...tdStyle, textAlign: 'center' }}>{raisedMonth}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmount}</td>

                        {/* Passed — inputs */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedMonth ?? ""}
                                onChange={(e) => handlePassedChange(index, "month", e.target.value)}
                                className={`modern-select ${errors[`month_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`month_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}`]}</div>
                            )}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedAmount ?? ""}
                                onChange={(e) => handlePassedChange(index, "amount", e.target.value)}
                                className={`modern-select ${errors[`amount_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`amount_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}`]}</div>
                            )}
                        </td>

                        {/* Deduction — auto-computed */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            {deductionMonth || 0}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            ₹{deductionAmount || 0}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add OfficeSupplies Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add OfficeSupplies Deductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>OfficeSupplies Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per item</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Item Description</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.boq_item}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>Raised month: {entry.actual_month}</div>
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Month</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// const UpdateFurnitureDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);

//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);
//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);





//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 invoice_amount: item.invoice_amount,
//                 remaining_amount: item.remaining_amount,
//                 cumulative_invoice_total: item.cumulative_invoice_total,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 actual_month: item.actual_month,

//             }));
//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))
//             setDeductionFormData(initialDeductionData)

//             setFormData(initialData);
//         }
//     }, [invoiceData]);


//     console.log("formData invoice")
//     console.log(invoiceData)
//     console.log("formData deductions")
//     console.log(formData)
//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => {
//             const newFields = [...prevFormData];
//             newFields[index] = {
//                 ...newFields[index],
//                 [name]: value,
//             };
//             return newFields;
//         });
//     }

//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Month cannot exceed actual Month"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = ((invoiceData[index]?.actual_month) || 0)
//                 const currentInvoiceAmountTwo = (invoiceData[index]?.invoice_amount || 0)

//                 const prevMonthTotal = (invoiceData[index]?.actual_month_total_previous || 0)
//                 const prevInvoiceTotal = (invoiceData[index]?.previous_invoice_total || 0)

//                 const cumulativeMonth = (invoiceData[index]?.actual_month_cumulative_total || 0)
//                 const cumulativeAmount = (invoiceData[index]?.cumulative_invoice_total || 0)

//                 const actualMonthTwoo = (
//                     Number(actualMonthTwo || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 const cumulativeMonthh = (
//                     Number(Number(actualMonthTwoo || 0) + Number(prevMonthTotal || 0)).toFixed(2)
//                 )




//                 const currentInvoiceAmountTwoo =
//                     Number(currentInvoiceAmountTwo || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 const cumulativeAmountt =
//                     Number(Number(prevInvoiceTotal || 0) + Number(currentInvoiceAmountTwoo || 0)).toFixed(2);

//                 // calculate sums

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month: actualMonthTwoo,
//                     invoice_amount: currentInvoiceAmountTwoo,
//                     actual_month_cumulative_total: cumulativeMonthh,
//                     cumulative_invoice_total: cumulativeAmountt,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])



//     return (
//         <>
//             <button title="Add OfficeFurniture Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add OfficeFurnitureDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add OfficeFurniture Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <Modal.Body>

//                             <div className='table-box scroll-container-table'>
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>
//                                             <th className="table-heading-text text-center">Month Raised  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>
//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Month</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>


//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>

//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }

//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </Modal.Body>
//                     </Modal>
//             }
//         </>


//     )
// }

const UpdateFurnitureDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, manual entry
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — NEW: Raised/Passed → auto Deduction.
        // Furniture line items are scalar (no per-employee/vehicle sub-items), so
        // these are single values per row, not arrays.
        passed_month: "",
        passed_amount: "",
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                invoice_amount: item.invoice_amount,
                remaining_amount: item.remaining_amount,
                cumulative_invoice_total: item.cumulative_invoice_total,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                actual_month: item.actual_month,
                actual_month_total_previous: item.actual_month_total_previous,
                previous_invoice_total: item.previous_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => ({
                deduction_reason: "",
                withheld_deduction_reason: "",
                invoice_type: "null",
                item_id: item.id,
                invoice_id: item.invoice,
                project: item.project,

                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",

                passed_month: "",
                passed_amount: "",
            }));

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // Shared cascade recompute for a row — scalar version (no arrays), used by
    // both the "Both" manual path and the "Deduction"/"WithHeldDeduction" passed path.
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];

            const actualMonth = Number(invoiceData[index]?.actual_month || 0);
            const currentInvoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);
            const prevMonthTotal = Number(invoiceData[index]?.actual_month_total_previous || 0);
            const prevInvoiceTotal = Number(invoiceData[index]?.previous_invoice_total || 0);

            const newActualMonth = Number((actualMonth - Number(deductionMonth || 0)).toFixed(2));
            const newInvoiceAmount = currentInvoiceAmount - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            const newCumulativeMonth = Number((prevMonthTotal + newActualMonth).toFixed(2));
            const newCumulativeAmount = Number((prevInvoiceTotal + newInvoiceAmount).toFixed(2));

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month: newActualMonth,
                invoice_amount: newInvoiceAmount,
                actual_month_cumulative_total: newCumulativeMonth,
                cumulative_invoice_total: newCumulativeAmount,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    // ---- "Both" path — unchanged, manual entry ----
    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0).toFixed(2);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0).toFixed(2);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Month cannot exceed actual Month" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — NEW Raised/Passed → auto Deduction ----
    // deduction_month             = raised_month  - passed_month
    // deduction_amount            = raised_amount - passed_amount   (type: Deduction)
    // withheld_deduction_amount   = raised_amount - passed_amount   (type: WithHeldDeduction)
    const handlePassedChange = (index, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month || 0);
        const raisedAmount = Number(invoiceData[index]?.invoice_amount || 0);

        const passedMonth = field === "month" ? value : (row.passed_month ?? "");
        const passedAmount = field === "amount" ? value : (row.passed_amount ?? "");

        const passedMonthNum = Number(passedMonth || 0);
        const passedAmountNum = Number(passedAmount || 0);

        if (field === "month" && passedMonthNum > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}`]: "Passed month cannot exceed raised month" }));
            return;
        }
        if (field === "amount" && passedAmountNum > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonthNum).toFixed(2));
        const deductionAmount = Number(raisedAmount - passedAmountNum).toFixed(2);

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            const updatedRow = {
                ...updated[index],
                passed_month: passedMonth,
                passed_amount: passedAmount,
                deduction_month: deductionMonth,
            };
            if (updated[index]?.invoice_type === "WithHeldDeduction") {
                updatedRow.withheld_deduction_amount = deductionAmount;
            } else {
                updatedRow.deduction_amount = deductionAmount;
            }
            updated[index] = updatedRow;
            return updated;
        });

        const isWithheld = row.invoice_type === "WithHeldDeduction";
        applyToFormData(index, deductionMonth, isWithheld ? 0 : deductionAmount, isWithheld ? deductionAmount : 0);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month: "",
                passed_amount: "",
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    useEffect(() => {
        const filterNullData = deductionformData
            .filter(item => item.invoice_type !== "null")
            .map(({ passed_month, passed_amount, ...rest }) => rest); // strip UI-only fields before submit
        if (filterNullData.length === 0) {
            setFinalDeductionFormData([]);
        } else {
            setFinalDeductionFormData(filterNullData);
        }
    }, [deductionformData]);

    // Raised (read-only) + Passed (input) + auto Deduction — single row per invoice
    // line item (furniture entries don't have per-employee/vehicle sub-items).
    const renderRaisedPassedRow = (index) => {
        const raisedMonth = invoiceData[index]?.actual_month;
        const raisedAmount = invoiceData[index]?.invoice_amount;
        const row = deductionformData[index] || {};
        const passedMonth = row.passed_month;
        const passedAmount = row.passed_amount;
        const deductionMonth = row.deduction_month;
        const deductionAmount = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount : row.deduction_amount;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={thSubStyle}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Month</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Month</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* Raised — read-only */}
                        <td style={{ ...tdStyle, textAlign: 'center' }}>{raisedMonth}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmount}</td>

                        {/* Passed — inputs */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedMonth ?? ""}
                                onChange={(e) => handlePassedChange(index, "month", e.target.value)}
                                className={`modern-select ${errors[`month_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`month_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}`]}</div>
                            )}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedAmount ?? ""}
                                onChange={(e) => handlePassedChange(index, "amount", e.target.value)}
                                className={`modern-select ${errors[`amount_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`amount_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}`]}</div>
                            )}
                        </td>

                        {/* Deduction — auto-computed */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            {deductionMonth || 0}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            ₹{deductionAmount || 0}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add OfficeFurniture Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add OfficeFurniture Deductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>OfficeFurniture Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per item</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Month / Amount Raised</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.actual_month} mo.</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>₹{entry.invoice_amount}</div>
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Month</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// const UpdateReportsDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);

//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});

//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);
//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);




//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 boq_description: item.boq_description,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 invoice_amount: item.invoice_amount,
//                 remaining_amount: item.remaining_amount,
//                 cumulative_invoice_total: item.cumulative_invoice_total,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 actual_month: item.actual_month,

//             }));
//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))
//             setDeductionFormData(initialDeductionData)
//             setFormData(initialData);
//         }
//     }, [invoiceData]);


//     console.log("formData invoice")
//     console.log(invoiceData)
//     console.log("formData deductions")
//     console.log(formData)
//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => {
//             const newFields = [...prevFormData];
//             newFields[index] = {
//                 ...newFields[index],
//                 [name]: value,
//             };
//             return newFields;
//         });
//     }

//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Copies cannot exceed Raised Copies"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = ((invoiceData[index]?.actual_month) || 0)
//                 const currentInvoiceAmountTwo = (invoiceData[index]?.invoice_amount || 0)

//                 const prevMonthTotal = (invoiceData[index]?.actual_month_total_previous || 0)
//                 const prevInvoiceTotal = (invoiceData[index]?.previous_invoice_total || 0)

//                 const cumulativeMonth = (invoiceData[index]?.actual_month_cumulative_total || 0)
//                 const cumulativeAmount = (invoiceData[index]?.cumulative_invoice_total || 0)

//                 const actualMonthTwoo = (
//                     Number(actualMonthTwo || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 const cumulativeMonthh = (
//                     Number(Number(actualMonthTwoo || 0) + Number(prevMonthTotal || 0)).toFixed(2)
//                 )




//                 const currentInvoiceAmountTwoo =
//                     Number(currentInvoiceAmountTwo || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 const cumulativeAmountt =
//                     Number(Number(prevInvoiceTotal || 0) + Number(currentInvoiceAmountTwoo || 0)).toFixed(2);

//                 // calculate sums

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month: actualMonthTwoo,
//                     invoice_amount: currentInvoiceAmountTwoo,
//                     actual_month_cumulative_total: cumulativeMonthh,
//                     cumulative_invoice_total: cumulativeAmountt,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])




//     return (
//         <>
//             <button title="Add Reports Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add ReportsDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add Reports Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <Modal.Body>

//                             <div className='table-box scroll-container-table'>
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>

//                                             <th className="table-heading-text text-center">Item Description <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Copies Raised  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>
//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Month</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>


//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.boq_description}</td>


//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }


//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </Modal.Body>
//                     </Modal>
//             }
//         </>


//     )
// }

const UpdateReportsDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, manual entry
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — NEW: Raised/Passed → auto Deduction.
        // Reports/document-printing line items are scalar (no per-employee/vehicle
        // sub-items), so these are single values per row, not arrays.
        passed_month: "",
        passed_amount: "",
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                boq_description: item.boq_description,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                invoice_amount: item.invoice_amount,
                remaining_amount: item.remaining_amount,
                cumulative_invoice_total: item.cumulative_invoice_total,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                actual_month: item.actual_month,
                actual_month_total_previous: item.actual_month_total_previous,
                previous_invoice_total: item.previous_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => ({
                deduction_reason: "",
                withheld_deduction_reason: "",
                invoice_type: "null",
                item_id: item.id,
                invoice_id: item.invoice,
                project: item.project,

                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",

                passed_month: "",
                passed_amount: "",
            }));

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Month / Amount";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // Shared cascade recompute for a row — scalar version (no arrays), used by
    // both the "Both" manual path and the "Deduction"/"WithHeldDeduction" passed path.
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];

            const actualMonth = Number(invoiceData[index]?.actual_month || 0);
            const currentInvoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);
            const prevMonthTotal = Number(invoiceData[index]?.actual_month_total_previous || 0);
            const prevInvoiceTotal = Number(invoiceData[index]?.previous_invoice_total || 0);

            const newActualMonth = Number((actualMonth - Number(deductionMonth || 0)).toFixed(2));
            const newInvoiceAmount = currentInvoiceAmount - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            const newCumulativeMonth = Number((prevMonthTotal + newActualMonth).toFixed(2));
            const newCumulativeAmount = Number((prevInvoiceTotal + newInvoiceAmount).toFixed(2));

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month: newActualMonth,
                invoice_amount: newInvoiceAmount,
                actual_month_cumulative_total: newCumulativeMonth,
                cumulative_invoice_total: newCumulativeAmount,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    // ---- "Both" path — unchanged, manual entry ----
    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Copies cannot exceed Raised Copies" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — NEW Raised/Passed → auto Deduction ----
    // deduction_month             = raised_copies - passed_copies
    // deduction_amount            = raised_amount  - passed_amount   (type: Deduction)
    // withheld_deduction_amount   = raised_amount  - passed_amount   (type: WithHeldDeduction)
    const handlePassedChange = (index, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month || 0);
        const raisedAmount = Number(invoiceData[index]?.invoice_amount || 0);

        const passedMonth = field === "month" ? value : (row.passed_month ?? "");
        const passedAmount = field === "amount" ? value : (row.passed_amount ?? "");

        const passedMonthNum = Number(passedMonth || 0);
        const passedAmountNum = Number(passedAmount || 0);

        if (field === "month" && passedMonthNum > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}`]: "Passed copies cannot exceed raised copies" }));
            return;
        }
        if (field === "amount" && passedAmountNum > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonthNum).toFixed(2));
        const deductionAmount = raisedAmount - passedAmountNum;

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            const updatedRow = {
                ...updated[index],
                passed_month: passedMonth,
                passed_amount: passedAmount,
                deduction_month: deductionMonth,
            };
            if (updated[index]?.invoice_type === "WithHeldDeduction") {
                updatedRow.withheld_deduction_amount = deductionAmount;
            } else {
                updatedRow.deduction_amount = deductionAmount;
            }
            updated[index] = updatedRow;
            return updated;
        });

        const isWithheld = row.invoice_type === "WithHeldDeduction";
        applyToFormData(index, deductionMonth, isWithheld ? 0 : deductionAmount, isWithheld ? deductionAmount : 0);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month: "",
                passed_amount: "",
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    useEffect(() => {
        const filterNullData = deductionformData
            .filter(item => item.invoice_type !== "null")
            .map(({ passed_month, passed_amount, ...rest }) => rest); // strip UI-only fields before submit
        if (filterNullData.length === 0) {
            setFinalDeductionFormData([]);
        } else {
            setFinalDeductionFormData(filterNullData);
        }
    }, [deductionformData]);

    // Raised (read-only) + Passed (input) + auto Deduction — single row per invoice
    // line item (reports/document-printing entries don't have per-employee/vehicle
    // sub-items).
    const renderRaisedPassedRow = (index) => {
        const raisedMonth = invoiceData[index]?.actual_month;
        const raisedAmount = invoiceData[index]?.invoice_amount;
        const row = deductionformData[index] || {};
        const passedMonth = row.passed_month;
        const passedAmount = row.passed_amount;
        const deductionMonth = row.deduction_month;
        const deductionAmount = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount : row.deduction_amount;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={thSubStyle}>Copies</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}>Copies</th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Copies</th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* Raised — read-only */}
                        <td style={{ ...tdStyle, textAlign: 'center' }}>{raisedMonth}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmount}</td>

                        {/* Passed — inputs */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedMonth ?? ""}
                                onChange={(e) => handlePassedChange(index, "month", e.target.value)}
                                className={`modern-select ${errors[`month_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`month_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}`]}</div>
                            )}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedAmount ?? ""}
                                onChange={(e) => handlePassedChange(index, "amount", e.target.value)}
                                className={`modern-select ${errors[`amount_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`amount_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}`]}</div>
                            )}
                        </td>

                        {/* Deduction — auto-computed */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            {deductionMonth || 0}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            ₹{deductionAmount || 0}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add Reports Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add ReportsDeductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>Reports &amp; Document Printing Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per item</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Item Description</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.boq_description}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>{entry.actual_month} copies · ₹{entry.invoice_amount}</div>
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Copies</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// const UpdateRoadSurveyDeductionInvoice = ({ invoiceData, getData }) => {


//     const [show, setShow] = useState(false)
//     const [formData, setFormData] = useState([]);

//     const handleShow = () => {
//         setShow(true);
//     }
//     const handleClose = () => {
//         setShow(false);
//     }
//     const [errors, setErrors] = useState({});
//     const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);
//     const [deductionformData, setDeductionFormData] = useState([{
//         deduction_reason: "",
//         deduction_amount: '',
//         deduction_month: "",
//         withheld_deduction_reason: "",
//         withheld_deduction_amount: "",
//         invoice_type: "null",
//         item_id: "",
//         invoice_id: "",
//         project: "",
//     }]);






//     useEffect(() => {
//         if (Array.isArray(invoiceData)) {
//             const initialData = invoiceData.map((item) => ({
//                 id: item.id,
//                 boq_description: item.boq_description,
//                 deduction_amount: item.deduction_amount,
//                 deduction_reason: item.deduction_reason,
//                 invoice_amount: item.invoice_amount,
//                 remaining_amount: item.remaining_amount,
//                 cumulative_invoice_total: item.cumulative_invoice_total,
//                 actual_month_remaining: item.actual_month_remaining,
//                 actual_month_cumulative_total: item.actual_month_cumulative_total,
//                 actual_month: item.actual_month,


//             }));
//             const initialDeductionData = invoiceData.map((item) => ({
//                 deduction_reason: "",
//                 deduction_amount: '',
//                 deduction_month: "",
//                 withheld_deduction_reason: "",
//                 withheld_deduction_amount: "",
//                 invoice_type: "null",
//                 item_id: item.id,
//                 invoice_id: item.invoice,
//                 project: item.project,
//             }))
//             setDeductionFormData(initialDeductionData)
//             setFormData(initialData);
//         }
//     }, [invoiceData]);


//     console.log("formData invoice")
//     console.log(invoiceData)
//     console.log("formData deductions")
//     console.log(formData)
//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => {
//             const newFields = [...prevFormData];
//             newFields[index] = {
//                 ...newFields[index],
//                 [name]: value,
//             };
//             return newFields;
//         });
//     }

//     const [loading, setLoading] = useState(false); //loading logic
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};

//         deductionformData.forEach((row, index) => {
//             if (row.invoice_type === "Both") {
//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }
//             }


//             // Deduction Validation
//             if (row.invoice_type === "Deduction") {

//                 if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") {
//                     newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
//                 }

//                 if (!row.deduction_reason || row.deduction_reason.trim() === "") {
//                     newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//             // Withheld Deduction Validation
//             if (row.invoice_type === "WithHeldDeduction") {

//                 if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") {
//                     newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
//                 }

//                 if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") {
//                     newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
//                 }

//                 if (!row.deduction_month) {
//                     newErrors[`deduction_month_${index}`] = "Deduction Month is required";
//                 }
//             }

//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentupdatedelete/null/`,
//                     formData,
//                     {
//                         onUploadProgress: (progressEvent) => {
//                             const percentCompleted = Math.round(
//                                 (progressEvent.loaded * 100) / progressEvent.total
//                             );
//                             setUploadProgress(percentCompleted);
//                         },
//                     }
//                 );

//                 if (res.status === 200) {
//                     try {
//                         const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
//                         if (res.status === 201 || res.status === 200) {
//                             await getData();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("Data Submitted Successfully");
//                             }, 4000);
//                         }
//                     } catch (error) {
//                         handleErrorToast(error, loadingToastId);
//                     }
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err, loadingToastId);
//             } finally {

//                 setTimeout(() => {
//                     setShowProgressModal(false);
//                 }, 2000); // Hide after 3 seconds

//                 setTimeout(() => {
//                     setLoading(false); //loading logic
//                     toast.dismiss(loadingToastId);
//                 }, 4000)

//             }
//         }
//     };

//     const handleDeductionChange = (e, index) => {
//         const { name, value } = e.target;
//         const numericValue = Number(value);

//         setDeductionFormData((prevData) => {
//             const updated = [...prevData];

//             const deductionAmount =
//                 name === "deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_amount || 0);

//             const withheldAmount =
//                 name === "withheld_deduction_amount"
//                     ? numericValue
//                     : Number(updated[index]?.withheld_deduction_amount || 0);

//             const deductionMonth =
//                 name === "deduction_month"
//                     ? numericValue
//                     : Number(updated[index]?.deduction_month || 0);

//             const actualMonth = Number(invoiceData[index]?.actual_month || 0);
//             const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

//             // ❌ negative validation
//             if (numericValue < 0) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]: "Value cannot be less than 0"
//                 }));
//                 return prevData;
//             }

//             // ❌ month validation
//             if (name === "deduction_month" && deductionMonth > actualMonth) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`deduction_month_${index}`]: "Copies cannot exceed Raised Copies"
//                 }));
//                 return prevData;
//             }

//             // ❌ amount validation
//             if (
//                 (name === "deduction_amount" || name === "withheld_deduction_amount") &&
//                 deductionAmount + withheldAmount > invoiceAmount
//             ) {
//                 setErrors((prev) => ({
//                     ...prev,
//                     [`${name}_${index}`]:
//                         "Total deduction cannot exceed invoice amount"
//                 }));
//                 return prevData;
//             }

//             // ✅ clear errors
//             setErrors((prev) => {
//                 const newErrors = { ...prev };
//                 delete newErrors[`${name}_${index}`];
//                 return newErrors;
//             });

//             updated[index] = {
//                 ...updated[index],
//                 [name]: value
//             };

//             setFormData((prevFormData) => {
//                 const updatedForm = [...prevFormData];

//                 const actualMonthTwo = ((invoiceData[index]?.actual_month) || 0)
//                 const currentInvoiceAmountTwo = (invoiceData[index]?.invoice_amount || 0)

//                 const prevMonthTotal = (invoiceData[index]?.actual_month_total_previous || 0)
//                 const prevInvoiceTotal = (invoiceData[index]?.previous_invoice_total || 0)

//                 const cumulativeMonth = (invoiceData[index]?.actual_month_cumulative_total || 0)
//                 const cumulativeAmount = (invoiceData[index]?.cumulative_invoice_total || 0)

//                 const actualMonthTwoo = (
//                     Number(actualMonthTwo || 0).toFixed(2) - Number(deductionMonth || 0)
//                 )
//                 const cumulativeMonthh = (
//                     Number(Number(actualMonthTwoo || 0) + Number(prevMonthTotal || 0)).toFixed(2)
//                 )




//                 const currentInvoiceAmountTwoo =
//                     Number(currentInvoiceAmountTwo || 0) - (Number(deductionAmount || 0) + Number(withheldAmount || 0));




//                 const cumulativeAmountt =
//                     Number(Number(prevInvoiceTotal || 0) + Number(currentInvoiceAmountTwoo || 0)).toFixed(2);

//                 // calculate sums

//                 updatedForm[index] = {
//                     ...updatedForm[index],
//                     actual_month: actualMonthTwoo,
//                     invoice_amount: currentInvoiceAmountTwoo,
//                     actual_month_cumulative_total: cumulativeMonthh,
//                     cumulative_invoice_total: cumulativeAmountt,
//                     actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
//                     remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
//                 };

//                 return updatedForm;
//             });
//             return updated;
//         });
//     };

//     const deductionType = [
//         { value: "Deduction", label: "Deduction" },
//         { value: "WithHeldDeduction", label: "Withheld Deduction" },
//         { value: "Both", label: "Both" },

//     ]

//     const deductionOptions = deductionType.map((option) => ({
//         value: option.value,
//         label: option.label,
//     }))

//     const deductionTypeChange = (selectedOption, index) => {
//         if (selectedOption) {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = selectedOption?.value || "";
//                 return updated;
//             });
//         } else {
//             setDeductionFormData((prevData) => {
//                 const updated = [...prevData];
//                 updated[index].invoice_type = "null";
//                 return updated;
//             });

//         }

//     };

//     useEffect(() => {
//         const filterNullData = deductionformData.filter(item => item.invoice_type !== "null");
//         if (filterNullData.length === 0) {
//             setFinalDeductionFormData([]);
//         }
//         else {
//             setFinalDeductionFormData(filterNullData);
//         }
//     }, [deductionformData])



//     return (
//         <>
//             <button title="Add RoadSurvey Invoice Deductions" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Add RoadSurveyDeductions
//             </button>
//             {
//                 showProgressModal ?
//                     <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
//                     <Modal
//                         show={show}
//                         onHide={handleClose}
//                         dialogClassName={"model-width60vw"}
//                     >
//                         <Modal.Header closeButton >
//                             <Modal.Title>Add RoadSurvey Invoice Deductions</Modal.Title>

//                         </Modal.Header>
//                         <Modal.Body>

//                             <div className='table-box scroll-container-table'>
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead className="table-heading">
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="table-heading-text text-left-sr" >S no.</th>

//                                             <th className="table-heading-text text-center"> Description <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Month Raised  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Raised Amount  <br /> <span className="required">(Read-Only)</span></th>
//                                             <th className="table-heading-text text-center">Deduction Type</th>
//                                             <th className="table-heading-text text-center">Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Deduction Copies</th>
//                                             <th className="table-heading-text text-center">Deduction Amount</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Reason</th>
//                                             <th className="table-heading-text text-center">Withheld Deduction Amount</th>


//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         {formData?.map((entry, index) => (
//                                             <tr key={index} className="custom-table-head-td ">
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td className="align-left width-5vw">{entry.boq_description}</td>
//                                                 <td className="align-left width-5vw">{entry.actual_month}</td>
//                                                 <td className="align-left width-5vw">{entry.invoice_amount}</td>

//                                                 <td className=''>

//                                                     <div className="mb-2">
//                                                         <Select
//                                                             options={deductionOptions}
//                                                             isSearchable
//                                                             isClearable
//                                                             onChange={(option) => deductionTypeChange(option, index)}
//                                                             placeholder="Select Deduction Type"
//                                                             value={deductionOptions.find(option => option.value === deductionformData[index]?.invoice_type) || "null"}
//                                                             styles={CSSForSelect10vWWidth}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {deductionformData[index]?.invoice_type === "Both" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>
//                                                             <div

//                                                                 title="Withheld Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "Deduction" &&
//                                                     <>

//                                                         <td>
//                                                             <div

//                                                                 title="Deduction Reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_reason_${index}`}
//                                                                     name="deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>


//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_amount_${index}`}
//                                                                     name="deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td colSpan={3} className='text-center'>No Value</td>

//                                                     </>
//                                                 }
//                                                 {deductionformData[index]?.invoice_type === "WithHeldDeduction" &&
//                                                     <>
//                                                         <td></td>
//                                                         <td>

//                                                             <div

//                                                                 title="Deduction Month"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`deduction_month_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`deduction_month_${index}`}
//                                                                     name="deduction_month"
//                                                                     type="number"
//                                                                     min="0"
//                                                                     max={formData[index]?.actual_month}
//                                                                     value={deductionformData[index]?.deduction_month || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`deduction_month_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`deduction_month_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>
//                                                         <td></td>
//                                                         <td>
//                                                             <div

//                                                                 title="WithHeld deduction reason"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >
//                                                                 <textarea
//                                                                     className={`form-input-input width-10vw ${errors[`withheld_deduction_reason_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_reason_${index}`}
//                                                                     name="withheld_deduction_reason"
//                                                                     style={{ padding: "10px" }}
//                                                                     value={deductionformData[index]?.withheld_deduction_reason || ""}
//                                                                     onChange={(e) => {
//                                                                         const { value } = e.target;

//                                                                         setDeductionFormData((prevData) => {
//                                                                             const updated = [...prevData];
//                                                                             updated[index] = {
//                                                                                 ...updated[index],
//                                                                                 withheld_deduction_reason: value
//                                                                             };
//                                                                             return updated;
//                                                                         });
//                                                                     }}
//                                                                 />

//                                                                 {errors[`withheld_deduction_reason_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_reason_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>



//                                                         <td>

//                                                             <div

//                                                                 title="Withheld Deduction Amount"
//                                                                 className="flex-column align-items-center mb-2"
//                                                             >


//                                                                 <input
//                                                                     className={`form-input-date width-10vw ${errors[`withheld_deduction_amount_${index}`] ? "error" : ""
//                                                                         }`}
//                                                                     id={`withheld_deduction_amount_${index}`}
//                                                                     name="withheld_deduction_amount"
//                                                                     type="number"
//                                                                     value={deductionformData[index]?.withheld_deduction_amount || ""}
//                                                                     onChange={(e) => handleDeductionChange(e, index)}
//                                                                 />

//                                                                 {errors[`withheld_deduction_amount_${index}`] && (
//                                                                     <span className="error-message font-size-text">
//                                                                         {errors[`withheld_deduction_amount_${index}`]}
//                                                                     </span>
//                                                                 )}
//                                                             </div>

//                                                         </td>

//                                                     </>
//                                                 }

//                                                 {deductionformData[index]?.invoice_type === "null" &&

//                                                     <td colSpan={5} className="text-center font-style-italic">Select Deduction Type</td>


//                                                 }

//                                             </tr>
//                                         ))}
//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>

//                         </Modal.Body>
//                     </Modal>
//             }
//         </>


//     )
// }

const UpdateRoadSurveyDeductionInvoice = ({ invoiceData, getData }) => {
    // Shared cell styles for the Raised/Passed/Deduction table
    const thStyle = { padding: '6px 8px', fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.03em', textAlign: 'left' };
    const thSubStyle = { padding: '4px 8px', fontSize: '10px', fontWeight: 600, color: '#94a3b8', textAlign: 'center' };
    const tdStyle = { padding: '8px', fontSize: '12px', color: '#334155' };

    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [finalDeductionFormData, setFinalDeductionFormData] = useState([]);

    const [deductionformData, setDeductionFormData] = useState([{
        deduction_reason: "",
        withheld_deduction_reason: "",
        invoice_type: "null",
        item_id: "",
        invoice_id: "",
        project: "",

        // "Both" — unchanged, manual entry
        deduction_month: "",
        deduction_amount: "",
        withheld_deduction_amount: "",

        // "Deduction" / "WithHeldDeduction" — NEW: Raised/Passed → auto Deduction.
        // Road-survey-equipment line items are scalar (no per-employee/vehicle
        // sub-items), so these are single values per row, not arrays.
        passed_month: "",
        passed_amount: "",
    }]);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(invoiceData)) {
            const initialData = invoiceData.map((item) => ({
                id: item.id,
                boq_description: item.boq_description,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                invoice_amount: item.invoice_amount,
                remaining_amount: item.remaining_amount,
                cumulative_invoice_total: item.cumulative_invoice_total,
                actual_month_remaining: item.actual_month_remaining,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                actual_month: item.actual_month,
                actual_month_total_previous: item.actual_month_total_previous,
                previous_invoice_total: item.previous_invoice_total,
            }));

            const initialDeductionData = invoiceData.map((item) => ({
                deduction_reason: "",
                withheld_deduction_reason: "",
                invoice_type: "null",
                item_id: item.id,
                invoice_id: item.invoice,
                project: item.project,

                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",

                passed_month: "",
                passed_amount: "",
            }));

            setDeductionFormData(initialDeductionData);
            setFormData(initialData);
        }
    }, [invoiceData]);

    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        deductionformData.forEach((row, index) => {
            if (row.invoice_type === "Both") {
                if (!row.deduction_amount || row.deduction_amount.toString().trim() === "") newErrors[`deduction_amount_${index}`] = "Deduction Amount is required";
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!row.deduction_month) newErrors[`deduction_month_${index}`] = "Deduction Month is required";
                if (!row.withheld_deduction_amount || row.withheld_deduction_amount.toString().trim() === "") newErrors[`withheld_deduction_amount_${index}`] = "Withheld Amount is required";
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
            }
            if (row.invoice_type === "Deduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.deduction_reason || row.deduction_reason.trim() === "") newErrors[`deduction_reason_${index}`] = "Deduction Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Copies / Amount";
            }
            if (row.invoice_type === "WithHeldDeduction") {
                const hasPassed = (row.passed_month !== "" && row.passed_month !== undefined) || (row.passed_amount !== "" && row.passed_amount !== undefined);
                if (!row.withheld_deduction_reason || row.withheld_deduction_reason.trim() === "") newErrors[`withheld_deduction_reason_${index}`] = "Withheld Reason is required";
                if (!hasPassed) newErrors[`deduction_month_${index}`] = "Enter Passed Copies / Amount";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentupdatedelete/null/`,
                formData,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    },
                }
            );

            if (res.status === 200) {
                try {
                    const res2 = await axios.post(`${BASE_URL}/siteproject/bulkinvoicededuction/`, finalDeductionFormData);
                    if (res2.status === 201 || res2.status === 200) {
                        await getData();
                        handleClose();
                        setTimeout(() => {
                            toast.dismiss(loadingToastId);
                            toast.success("Data Submitted Successfully");
                        }, 4000);
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                }
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => {
                setShowProgressModal(false);
            }, 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // Shared cascade recompute for a row — scalar version (no arrays), used by
    // both the "Both" manual path and the "Deduction"/"WithHeldDeduction" passed path.
    const applyToFormData = (index, deductionMonth, deductionAmount, withheldAmount) => {
        setFormData((prevFormData) => {
            const updatedForm = [...prevFormData];

            const actualMonth = Number(invoiceData[index]?.actual_month || 0);
            const currentInvoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);
            const prevMonthTotal = Number(invoiceData[index]?.actual_month_total_previous || 0);
            const prevInvoiceTotal = Number(invoiceData[index]?.previous_invoice_total || 0);

            const newActualMonth = Number((actualMonth - Number(deductionMonth || 0)).toFixed(2));
            const newInvoiceAmount = currentInvoiceAmount - (Number(deductionAmount || 0) + Number(withheldAmount || 0));
            const newCumulativeMonth = Number((prevMonthTotal + newActualMonth).toFixed(2));
            const newCumulativeAmount = Number((prevInvoiceTotal + newInvoiceAmount).toFixed(2));

            updatedForm[index] = {
                ...updatedForm[index],
                actual_month: newActualMonth,
                invoice_amount: newInvoiceAmount,
                actual_month_cumulative_total: newCumulativeMonth,
                cumulative_invoice_total: newCumulativeAmount,
                actual_month_remaining: Number(invoiceData[index]?.actual_month_remaining) + Number(deductionMonth || 0),
                remaining_amount: Number(invoiceData[index]?.remaining_amount) + (Number(deductionAmount || 0) + Number(withheldAmount || 0)),
            };

            return updatedForm;
        });
    };

    // ---- "Both" path — unchanged, manual entry ----
    const handleDeductionChange = (e, index) => {
        const { name, value } = e.target;
        const numericValue = Number(value);

        const row = deductionformData[index] || {};
        const deductionAmount = name === "deduction_amount" ? numericValue : Number(row.deduction_amount || 0);
        const withheldAmount = name === "withheld_deduction_amount" ? numericValue : Number(row.withheld_deduction_amount || 0);
        const deductionMonth = name === "deduction_month" ? numericValue : Number(row.deduction_month || 0);
        const actualMonth = Number(invoiceData[index]?.actual_month || 0);
        const invoiceAmount = Number(invoiceData[index]?.invoice_amount || 0);

        if (numericValue < 0) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Value cannot be less than 0" }));
            return;
        }
        if (name === "deduction_month" && deductionMonth > actualMonth) {
            setErrors((prev) => ({ ...prev, [`deduction_month_${index}`]: "Copies cannot exceed Raised Copies" }));
            return;
        }
        if ((name === "deduction_amount" || name === "withheld_deduction_amount") && deductionAmount + withheldAmount > invoiceAmount) {
            setErrors((prev) => ({ ...prev, [`${name}_${index}`]: "Total deduction cannot exceed invoice amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${name}_${index}`];
            return newErrors;
        });

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = { ...updated[index], [name]: value };
            return updated;
        });

        applyToFormData(index, deductionMonth, deductionAmount, withheldAmount);
    };

    // ---- "Deduction" / "WithHeldDeduction" path — NEW Raised/Passed → auto Deduction ----
    // deduction_month             = raised_copies - passed_copies
    // deduction_amount            = raised_amount  - passed_amount   (type: Deduction)
    // withheld_deduction_amount   = raised_amount  - passed_amount   (type: WithHeldDeduction)
    const handlePassedChange = (index, field, value) => {
        const numericValue = Number(value);
        if (value !== "" && (isNaN(numericValue) || numericValue < 0)) {
            setErrors((prev) => ({ ...prev, [`${field}_${index}`]: "Value cannot be less than 0" }));
            return;
        }

        const row = deductionformData[index] || {};
        const raisedMonth = Number(invoiceData[index]?.actual_month || 0);
        const raisedAmount = Number(invoiceData[index]?.invoice_amount || 0);

        const passedMonth = field === "month" ? value : (row.passed_month ?? "");
        const passedAmount = field === "amount" ? value : (row.passed_amount ?? "");

        const passedMonthNum = Number(passedMonth || 0);
        const passedAmountNum = Number(passedAmount || 0);

        if (field === "month" && passedMonthNum > raisedMonth) {
            setErrors((prev) => ({ ...prev, [`month_${index}`]: "Passed copies cannot exceed raised copies" }));
            return;
        }
        if (field === "amount" && passedAmountNum > raisedAmount) {
            setErrors((prev) => ({ ...prev, [`amount_${index}`]: "Passed amount cannot exceed raised amount" }));
            return;
        }

        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${field}_${index}`];
            delete newErrors[`deduction_month_${index}`];
            return newErrors;
        });

        const deductionMonth = Number((raisedMonth - passedMonthNum).toFixed(2));
        const deductionAmount = raisedAmount - passedAmountNum;

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            const updatedRow = {
                ...updated[index],
                passed_month: passedMonth,
                passed_amount: passedAmount,
                deduction_month: deductionMonth,
            };
            if (updated[index]?.invoice_type === "WithHeldDeduction") {
                updatedRow.withheld_deduction_amount = deductionAmount;
            } else {
                updatedRow.deduction_amount = deductionAmount;
            }
            updated[index] = updatedRow;
            return updated;
        });

        const isWithheld = row.invoice_type === "WithHeldDeduction";
        applyToFormData(index, deductionMonth, isWithheld ? 0 : deductionAmount, isWithheld ? deductionAmount : 0);
    };

    const deductionType = [
        { value: "Deduction", label: "Deduction" },
        { value: "WithHeldDeduction", label: "Withheld Deduction" },
        { value: "Both", label: "Both" },
    ];
    const deductionOptions = deductionType.map((option) => ({ value: option.value, label: option.label }));

    const deductionTypeChange = (selectedOption, index) => {
        const newType = selectedOption ? selectedOption.value : "null";

        setDeductionFormData((prevData) => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                invoice_type: newType,
                deduction_month: "",
                deduction_amount: "",
                withheld_deduction_amount: "",
                passed_month: "",
                passed_amount: "",
            };
            return updated;
        });

        // Reset the row's cascade back to the raw invoiceData baseline.
        applyToFormData(index, 0, 0, 0);

        setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(newErrors).forEach((key) => {
                if (key.endsWith(`_${index}`)) delete newErrors[key];
            });
            return newErrors;
        });
    };

    useEffect(() => {
        const filterNullData = deductionformData
            .filter(item => item.invoice_type !== "null")
            .map(({ passed_month, passed_amount, ...rest }) => rest); // strip UI-only fields before submit
        if (filterNullData.length === 0) {
            setFinalDeductionFormData([]);
        } else {
            setFinalDeductionFormData(filterNullData);
        }
    }, [deductionformData]);

    // Raised (read-only) + Passed (input) + auto Deduction — single row per invoice
    // line item (road-survey-equipment entries don't have per-employee/vehicle
    // sub-items).
    const renderRaisedPassedRow = (index) => {
        const raisedMonth = invoiceData[index]?.actual_month;
        const raisedAmount = invoiceData[index]?.invoice_amount;
        const row = deductionformData[index] || {};
        const passedMonth = row.passed_month;
        const passedAmount = row.passed_amount;
        const deductionMonth = row.deduction_month;
        const deductionAmount = row.invoice_type === "WithHeldDeduction" ? row.withheld_deduction_amount : row.deduction_amount;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                <thead>
                    <tr style={{ background: '#f8fafc' }}>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center' }}>Raised</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0' }}>Passed</th>
                        <th colSpan={2} style={{ ...thStyle, textAlign: 'center', borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}>Deduction</th>
                    </tr>
                    <tr style={{ background: '#f8fafc' }}>
                        <th style={thSubStyle}><span className="badge-label">No. of Survey</span></th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0' }}><span className="badge-label">No. of Survey</span></th>
                        <th style={thSubStyle}>Amount</th>
                        <th style={{ ...thSubStyle, borderLeft: '1px solid #e2e8f0', color: '#b91c1c' }}><span className="badge-label">No. of Survey</span></th>
                        <th style={{ ...thSubStyle, color: '#b91c1c' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {/* Raised — read-only */}
                        <td style={{ ...tdStyle, textAlign: 'center' }}>{raisedMonth}</td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>₹{raisedAmount}</td>

                        {/* Passed — inputs */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedMonth ?? ""}
                                onChange={(e) => handlePassedChange(index, "month", e.target.value)}
                                className={`modern-select ${errors[`month_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`month_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`month_${index}`]}</div>
                            )}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center' }}>
                            <input
                                type="number"
                                min="0"
                                value={passedAmount ?? ""}
                                onChange={(e) => handlePassedChange(index, "amount", e.target.value)}
                                className={`modern-select ${errors[`amount_${index}`] ? "error" : ""}`}
                                style={{ width: '70px', fontSize: '12px' }}
                            />
                            {errors[`amount_${index}`] && (
                                <div className="error-message" style={{ fontSize: '10px' }}>{errors[`amount_${index}`]}</div>
                            )}
                        </td>

                        {/* Deduction — auto-computed */}
                        <td style={{ ...tdStyle, textAlign: 'center', borderLeft: '1px solid #f1f5f9', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            {deductionMonth || 0}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'center', background: '#fef2f2', fontWeight: 600, color: '#b91c1c' }}>
                            ₹{deductionAmount || 0}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    return (
        <>
            <button title="Add RoadSurvey Invoice Deductions" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <PlusCircle size={13} /> Add RoadSurveyDeductions
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Wallet size={24} />
                            </div>
                            <div>
                                <Modal.Title>RoadSurvey Equipment Invoice Deductions</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Add deductions per item</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">
                        <div className="table-wrapper-minimal table-box scroll-container-table" style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                            <table className="progress-table-minimal" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className="table-heading">
                                    <tr style={{ background: '#f1f5f9' }}>
                                        <th className="col-sno" style={{ width: '4%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>#</th>
                                        <th className="col-period" style={{ width: "16%", padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Item Description</th>
                                        <th className="col-period" style={{ width: '13%', padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Type</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Deduction Details</th>
                                        <th className="col-period" style={{ padding: '10px 8px', fontSize: '11px', fontWeight: 700, color: '#475569', textAlign: 'left' }}>Withheld Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((entry, index) => {
                                        const rowType = deductionformData[index]?.invoice_type;
                                        return (
                                            <tr
                                                key={index}
                                                className="progress-row"
                                                style={{
                                                    background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                                                }}
                                            >
                                                <td className="col-sno text-start" style={{ padding: '12px 8px', verticalAlign: 'top' }}>{index + 1}.</td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 600 }}>{entry.boq_description}</div>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>{entry.actual_month} copies · ₹{entry.invoice_amount}</div>
                                                </td>
                                                <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                    <Select
                                                        options={deductionOptions}
                                                        isSearchable
                                                        isClearable
                                                        onChange={(option) => deductionTypeChange(option, index)}
                                                        placeholder="Select Type"
                                                        value={deductionOptions.find(option => option.value === rowType) || null}
                                                        styles={CSSForSelectModern10VWWidth}
                                                    />
                                                </td>

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Copies</span>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max={formData[index]?.actual_month}
                                                                value={deductionformData[index]?.deduction_month || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_month", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`deduction_amount_${index}`] && <span className="error-message">{errors[`deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "Deduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Deduction Reason"
                                                                className={errors[`deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`deduction_reason_${index}`] && <span className="error-message">{errors[`deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ fontStyle: 'italic', color: '#94a3b8', padding: '12px 8px' }}>—</td>
                                                )}

                                                {rowType === "Both" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        <div className="progress-badge approved" style={{ gap: '6px' }}>
                                                            <span className="badge-label">Amount</span>
                                                            <input
                                                                type="number"
                                                                value={deductionformData[index]?.withheld_deduction_amount || ""}
                                                                onChange={(e) => handleDeductionChange({ target: { name: "withheld_deduction_amount", value: e.target.value } }, index)}
                                                                className="modern-select"
                                                                style={{ width: '90px' }}
                                                            />
                                                        </div>
                                                        {errors[`withheld_deduction_amount_${index}`] && <span className="error-message">{errors[`withheld_deduction_amount_${index}`]}</span>}
                                                    </td>
                                                ) : rowType === "WithHeldDeduction" ? (
                                                    <td className="col-period" style={{ padding: '12px 8px', verticalAlign: 'top' }}>
                                                        <div className="form-field" style={{ marginBottom: '6px' }}>
                                                            <textarea
                                                                placeholder="Withheld Reason"
                                                                className={errors[`withheld_deduction_reason_${index}`] ? "error" : ""}
                                                                value={deductionformData[index]?.withheld_deduction_reason || ""}
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setDeductionFormData((prevData) => {
                                                                        const updated = [...prevData];
                                                                        updated[index] = { ...updated[index], withheld_deduction_reason: value };
                                                                        return updated;
                                                                    });
                                                                }}
                                                            />
                                                            {errors[`withheld_deduction_reason_${index}`] && <span className="error-message">{errors[`withheld_deduction_reason_${index}`]}</span>}
                                                        </div>
                                                        {renderRaisedPassedRow(index)}
                                                        {errors[`deduction_month_${index}`] && <span className="error-message">{errors[`deduction_month_${index}`]}</span>}
                                                    </td>
                                                ) : (
                                                    <td className="col-period text-center" style={{ color: '#cbd5e1', padding: '12px 8px' }}>-</td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="form-actions" style={{ marginTop: '16px' }}>
                            <div></div>
                            <div className="submit-buttons">
                                <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                {deductionformData.some(row => row.invoice_type !== "null") && (
                                    <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                                        {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                                        <span>{loading ? 'Submitting...' : 'Submit'}</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

export {
    UpdateEmployeeDeductionInvoice,
    UpdateTransportDeductionInvoice,
    UpdateTravelDeductionInvoice,
    UpdateRentDeductionInvoice,
    UpdateSuppliesDeductionInvoice,
    UpdateFurnitureDeductionInvoice,
    UpdateReportsDeductionInvoice,
    UpdateRoadSurveyDeductionInvoice,
}